import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, MenuItem, Stack, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Header from '../../../components/Header'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import AddIcon from '@mui/icons-material/Add';
import { addDispatchProcess, editDispatchProcess, getAllDataForCommercialmarket, getDispatchProcess, getProcesscategory, getProcesskitproduct, getProcessproduct, getProcesssubcategory, getprocessSuggestion, getProcesswarehouse } from '../../../redux/slice/dispatchProcess.slice';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import PrintIcon from '@mui/icons-material/Print';
import { format } from 'date-fns';

import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import LexendBold from "../../../fonts/Lexend-Bold.ttf";
import LexendRegular from "../../../fonts/Lexend-Regular.ttf";
import QtyInputNested from './QtyInputNested';
pdfMake.vfs = pdfFonts.pdfMake.vfs; // Use default vfs as a base

const getLexendFonts = async () => {
    const fetchFont = async (fontPath) => {

        const response = await fetch(fontPath);
        const buffer = await response.arrayBuffer();

        return bufferToBase64(buffer);
    };

    const regularFont = await fetchFont(LexendRegular);
    const boldFont = await fetchFont(LexendBold);




    pdfMake.vfs['Lexend-Regular.ttf'] = regularFont;
    pdfMake.vfs['Lexend-Bold.ttf'] = boldFont;

    pdfMake.fonts = {
        Lexend: {
            normal: 'Lexend-Regular.ttf',
            bold: 'Lexend-Bold.ttf',
        },
    };


};

const bufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const getBase64Image = (img) => {
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
        };
        image.src = img;
    });
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
    ...(ownerState.error && {
        border: '2px solid red',
    }),
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, theme, error, children } = props;
    return (
        <ColorlibStepIconRoot ownerState={{ completed, active, error }} className={className} onClick={onClick}>
            {children}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    error: PropTypes.bool,
};
const steps = ['Vendor Details', 'Contact Person Details', 'Business Document Details', 'Vendor Type', 'Bank Details'];

const BulkDispatch = () => {
    const getuserId = localStorage.getItem("id");
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [activeStep, setActiveStep] = React.useState(0);
    const [stepsWithErrors, setStepsWithErrors] = React.useState([false, false, false, false, false]);
    const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);
    const { state } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const printRef = useRef();
    const [selectedDispatchProcesses] = useState(state?.selectedDispatchProcess || []);
    const [selectedMarketData] = useState(state?.selectedMarketData || []);
    const [mid, setMid] = useState(selectedMarketData?.map(m => m._id) || []);
    const [id, setId] = useState(state?.dispatchProcessId || '');
    const [bulkId, setBulkId] = useState(Date.now() + '-' + Math.round(Math.random() * 1E9));
    const suggestiondata = useSelector(state => state.dispatchProcess.suggestion)
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isMobile = useMediaQuery('(max-width:500px)');
    const categories = useSelector(state => state.dispatchProcess.category)
    const subcategories = useSelector(state => state.dispatchProcess.subCategory)
    const products = useSelector(state => state.dispatchProcess.products)
    const AlldispatchProcess = useSelector(state => state.dispatchProcess.dispatchProcess).filter(process => mid.includes(process.marketId));
    const [processData, setProcessData] = useState([]);
    const [dispatchDetails, setDispatchDetails] = useState([]);
    const warehousedata = useSelector(state => state.dispatchProcess.warehouse)
    const [selectedDispatchSuggestions, setSelectedDispatchSuggestions] = useState([]);
    const Market = useSelector(state => state.dispatchProcess.commercialMarket)
        ?.filter(market => mid.includes(market._id))
        .sort((a, b) => mid.indexOf(a._id) - mid.indexOf(b._id));


    const [disableSubmit, setDisableSubmit] = useState(false);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);


    useEffect(() => {
        getLexendFonts();
    }, []);

    useEffect(() => {
        const savedStatus = localStorage.getItem('formSubmitted');

        console.log(savedStatus, isSubmitted, "savedStatus")
        if (savedStatus === 'true') {
            setIsSubmitted(true);
        }

        return () => {
            // Cleanup when component unmounts
            localStorage.removeItem('formSubmitted');
        };
    }, []);

    // console.log(localStorage.getItem('formSubmitted'), isSubmitted, "savedStatus")

    const [dispatchProcessId, setDispatchProcessId] = useState(null);
    const [selectedPurchase, setSelectedPurchase] = useState(null);

    const FileNos = [...Market?.map(m => m.fillNo) || [], 'Total'];
    const isLastStep = activeStep === FileNos.length - 1;
    const [bulkDispatch, setBulkDispatch] = useState([]);
    const kitproductdata = useSelector(state => state.dispatchProcess.kitproduct)
    const [selectedKit, setSelectedKit] = useState([]);
    const [dialogValues, setDialogValues] = useState({
        DebitCreditWarehouseName: state?.selectedMarketData[0].wareHouseData[0]?._id,
        DispatchModelTransport: '',
        DispatchRemarks: ''
    });

    const kitCategoryId = categories.find(cat => cat.categoryName === 'KitCategory')?._id;
    const kitSubCategoryId = subcategories.find(sub => sub.subCategoryName === 'KitSubCategory')?._id;

    const storeData = useSelector((state) => state.dispatchProcess.store);


    const [selectedDispatchProcess, setSelectedDispatchProcess] = useState([]);

    // useEffect(() => {
    //     setSelectedDispatchProcess(AlldispatchProcess)
    // }, [AlldispatchProcess]);


    let highlightFlag = false;

    useEffect(() => {
        setDisableSubmit(highlightFlag);
    }, [highlightFlag]);



    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleNext = () => {
        if (!isLastStep) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            handleOpen();
        }
    };

    const handleStep = (step) => {
        setActiveStep(step);
    };
    useEffect(() => {
        dispatch(getProcesscategory())
        dispatch(getProcesssubcategory())
        dispatch(getProcessproduct())
        dispatch(getProcesswarehouse())
        dispatch(getprocessSuggestion())
        dispatch(getProcesskitproduct())
        dispatch(getAllDataForCommercialmarket());
        dispatch(getDispatchProcess());
    }, [dispatch])

    useEffect(() => {
        if (mid) {
            dispatch(getDispatchProcess());
        }
    }, [mid, id]);

    useEffect(() => {
        if (id && AlldispatchProcess) {
            setValues(AlldispatchProcess);
            setProcessData(AlldispatchProcess?.ProcessData);
        }
    }, [id, AlldispatchProcess]);


    // const handleSubmit = async () => {
    //     if (!mid.length) {
    //         alert("No markets selected for dispatch.");
    //         return;
    //     }
    //     try {
    //         await validationSchemas.validate(values, { abortEarly: false });
    //     } catch (err) {

    //         alert("Please fill all required fields");
    //         return;
    //     }

    //     for (const [index, marketProcess] of values.entries()) {
    //         const submissionValues = {
    //             marketId: marketProcess.marketId,
    //             ProcessData: marketProcess.ProcessData.map(process => ({
    //                 ...process,
    //                 bulkId: bulkId,
    //                 PurposeofDispatch: process.PurposeofDispatch,
    //                 DispatchModelTransport: dialogValues.DispatchModelTransport,
    //                 DispatchRemarks: dialogValues.DispatchRemarks,
    //                 DebitCreditWarehouseName: dialogValues.DebitCreditWarehouseName,
    //                 DispatchDate: process.DispatchDate,
    //                 DispatchSuggestionId: process.DispatchSuggestionId || null,
    //                 DispatchDetails: process.DispatchDetails.map(detail => ({
    //                     ...detail,
    //                     DispatchKitId: detail.DispatchKitId || null,
    //                 }))
    //             }))
    //         };

    //         const marketDispatchProcess = AlldispatchProcess.find(process => process.marketId == marketProcess.marketId);
    //         const process = submissionValues.ProcessData.map(process => ({
    //             ...process,
    //             DispatchDetails: process.DispatchDetails.filter(detail => detail.DispatchProductName != '')
    //         }));
    //         submissionValues.ProcessData = process;
    //         const newProcessData = submissionValues.ProcessData.splice(0, marketDispatchProcess?.ProcessData?.length);

    //         if (selectedDispatchProcesses[index]?._id) {
    //             await dispatch(editDispatchProcess({
    //                 _id: selectedDispatchProcesses[index]._id,
    //                 ...submissionValues
    //             }));
    //         } else {
    //             await dispatch(addDispatchProcess({ data: submissionValues }));
    //         }
    //     }
    //     resetForm();
    //     handleClose();
    // };
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        console.log(isSubmitting, "isSubmittinga");
        
        if (isSubmitting) return; // Exit if already processing
        setIsSubmitting(true);
        let marketValues = Array.isArray(values) ? values : [values]; // Ensure values is always an array
        let marketIds = Array.isArray(mid) ? mid : [mid]; // Ensure mid is always an array

        if (marketIds.some(id => !id)) {
            alert("Market ID is not defined.");
            return;
        }






        try {



            // Validate each market separately
            for (let i = 0; i < marketValues.length; i++) {
                const value = marketValues[i];
                const marketId = marketIds[i];

                const MarketData = Market?.find(m => m._id === marketId) || ''

                //User entered data
                const ee = values?.find(v => v?.marketId == marketId);

                //dispatched data
                const dd = AlldispatchProcess?.find(v => v?.marketId == marketId);

                let dispatchedQty = 0;
                dd?.ProcessData?.forEach((v) => {
                    if (v?.PurposeofDispatch === 'Customer Material') {
                        const x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8c7864db29472435057");

                        console.log("yyyyyyyyyyyyyyyyyyyyyyy", x);
                        if (x) {
                            dispatchedQty += parseInt(x?.DispatchQty || 0);
                        }
                    }
                });

                let enteredQty = 0;
                ee?.ProcessData?.forEach((v) => {
                    if (v?.PurposeofDispatch === 'Customer Material') {
                        const x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8c7864db29472435057");

                        console.log("yyyyyyyyyyyyyyyyyyyyyyy", x);
                        if (x) {
                            enteredQty += parseInt(x?.DispatchQty || 0);
                        }
                    }
                });


                console.log("eeddddddddddddddsssss",
                    ee, parseInt(MarketData?.SolarModuleNos), parseInt(enteredQty),
                    parseInt(MarketData?.SolarModuleNos) < parseInt(enteredQty));

                if (parseInt(MarketData?.SolarModuleNos) < parseInt(enteredQty)) {
                    alert("Solar PV Dispatch Quantity exceed for " + MarketData?.fillNo);
                    return;
                }

                let enteredQtyInv = 0;

                ee?.ProcessData?.forEach((v) => {
                    if (v?.PurposeofDispatch === 'Customer Material') {
                        const x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8bf864db29472435052");

                        console.log("yyyyyyyyyyyyyyyyyyyyyyy", x);


                        if (x) {
                            enteredQtyInv += parseInt(x?.DispatchQty || 0);
                        }
                    }
                });

                if (enteredQtyInv > 1 && MarketData?.MarketingType === "Residential") {
                    alert("Solar Inverter Quantity must be 1 for " + MarketData?.fillNo);
                    return;
                }


                await validationSchemas.validate([value], {
                    abortEarly: false,
                });
            }

            // ✅ All validations passed
            // alert("Validation successful!");
        } catch (err) {
            if (err.inner && err.inner.length > 0) {
                const errorMessages = err.inner.map(e => e.message).join('\n');
                alert("Please fill all required fields:\n" + errorMessages);
            } else {
                alert("Validation failed: " + err.message);
            }

            return;
        }

        try {
            for (const [index, marketProcess] of marketValues.entries()) {
                const currentMid = marketIds[index];
                const currentMarket = Array.isArray(Market) ? Market[index] : Market;
                const currentAlldispatchProcess = Array.isArray(AlldispatchProcess) ? AlldispatchProcess[index] : AlldispatchProcess;
                const currentSelectedDispatchProcesses = Array.isArray(selectedDispatchProcesses) ? selectedDispatchProcesses[index] : selectedDispatchProcesses;

                const uniqueData = marketProcess.ProcessData.map((v) => {
                    if (!v?.generatedNumber) {
                        let kitCounter = 1;
                        let flatDispatchDetails = v.DispatchDetails.flatMap((detail) => {
                            let x = kitproductdata.find((kp) => kp._id === detail.DispatchProductName);

                            if (x) {
                                const currentKitNo = kitCounter++;
                                return x.KitDetails.map((kit) => ({
                                    DispatchKitId: x._id,
                                    DispatchCatogory: kit.KitCatogory,
                                    DispatchSubCatogory: kit.KitSubCatogory,
                                    DispatchProductName: kit.KitProductName,
                                    DispatchDiscription: kit.KitDiscription,
                                    DispatchUnit: kit.KitUnit,
                                    DispatchQty: kit.KitQty,
                                    KitNo: currentKitNo,
                                }));
                            } else if (detail.DispatchKitDetails) {
                                const currentKitNo = kitCounter++;
                                return detail.DispatchKitDetails.map((kit) => ({
                                    DispatchKitId: v.DispatchProductName,
                                    DispatchCatogory: kit.KitCatogory,
                                    DispatchSubCatogory: kit.KitSubCatogory,
                                    DispatchProductName: kit.KitProductName,
                                    DispatchDiscription: kit.KitDiscription,
                                    DispatchUnit: kit.KitUnit,
                                    DispatchQty: kit.KitQty,
                                    KitNo: currentKitNo,
                                }));
                            } else if (!detail.DispatchKitId) {
                                return detail;
                            } else {
                                return detail;
                            }
                        });

                        return {
                            ...v,
                            DispatchDetails: flatDispatchDetails,
                        };
                    } else {
                        return v;
                    }
                });

                const submissionValues = {
                    ...marketProcess,
                    marketId: currentMid,
                    dispatchBy: getuserId,
                    bulkId: bulkId,
                    PendingPayment: (() => {
                        if (!currentMarket?.AccountData || currentMarket?.AccountData.length === 0) {
                            return 'No Account Data Available';
                        }

                        const accountDetails = currentMarket.AccountData[0]?.AccountDetails || [];
                        const totalAccountAmount = accountDetails.reduce(
                            (sum, account) => sum + parseFloat(account.AccountAmount || 0),
                            0
                        );

                        const remainingAmount = parseFloat(currentMarket.TotalAmount || 0) - totalAccountAmount;

                        return remainingAmount > 0 ? `${remainingAmount}` : 'Fully Paid';
                    })(),
                    ProcessData: uniqueData.map((process) => {
                        const processData = {
                            ...process,
                            DispatchSuggestionId: process.DispatchSuggestionId || null,
                        };
                        return processData;
                    }),
                };




                const process = submissionValues.ProcessData.map((process) => ({
                    ...process,
                    DispatchDetails: process.DispatchDetails.filter((detail) => detail.DispatchProductName != ''),
                }));

                submissionValues.ProcessData = process;
                const newProcessData = submissionValues.ProcessData.splice(0, currentAlldispatchProcess?.ProcessData?.length);

                let res;
                if (Array.isArray(selectedDispatchProcesses) ? currentSelectedDispatchProcesses?._id : id) {
                    delete submissionValues.isActive;
                    delete submissionValues.createdAt;
                    delete submissionValues.updatedAt;




                    res = await dispatch(editDispatchProcess({
                        _id: Array.isArray(selectedDispatchProcesses) ? currentSelectedDispatchProcesses._id : id,
                        ...submissionValues, bulkId: bulkId,
                    }));

                    if (res.error) {
                        setIsSubmitting(false);
                        return; // Stop loop if one fails
                    }
                } else {



                    res = await dispatch(addDispatchProcess({ data: submissionValues }));

                    if (res.error) {
                        setIsSubmitting(false);
                        return; // Stop loop if one fails
                    }
                }

                if (res.type === "dispatchProcess/add/fulfilled" || res.type === "dispatchProcess/edit/fulfilled") {
                    localStorage.setItem("bulkId", bulkId);
                    setIsSubmitted(true);
                    localStorage.setItem('formSubmitted', 'true');
                }


            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false); // Re-enable
        }


        // resetForm();
        handleClose();
    };


    const validationSchemas = Yup.array().of(
        Yup.object().shape({
            marketId: Yup.string().required('Market ID is required'),
            ProcessData: Yup.array().of(
                Yup.object().shape({
                    PurposeofDispatch: Yup.string().required('Purpose of Dispatch is required'),
                    DispatchDate: Yup.string().required('Dispatch Date is required'),
                    DispatchDetails: Yup.array().of(
                        Yup.object().shape({
                            DispatchCatogory: Yup.string().required('Dispatch Category is required'),
                            DispatchSubCatogory: Yup.string().required('Dispatch Sub Category is required'),
                            DispatchProductName: Yup.string().test('required', 'Dispatch Product Name is required', function (value) {
                                const { parent } = this;
                                return parent.DispatchKitId ? true : !!value;
                            }),
                            DispatchQty: Yup.mixed().test(
                                'required-and-valid',
                                'Dispatch Quantity is required and must be greater than 0 and less than or equal allowed quantity.',
                                function (value) {
                                    const { parent, options } = this;
                                    const contextData = options.context;

                                    console.log("Context Data:", contextData, value);
                                    if (parent.DispatchKitId) return true;
                                    const numberValue = Number(value);

                                    console.log("parent", parent);

                                    if (parseInt(value) > (parseInt(contextData?.totalAllowSolarPV) + parseInt(contextData?.dispatchedSolarPV))) {
                                        return false
                                    }

                                    return Number.isInteger(numberValue) && numberValue > 0;
                                }
                            ),
                        })
                    ).required('Dispatch Details are required'),
                })
            ).required('Process Data is required'),
        })
    ).required('Array of market data is required');


    const getInitialValues = (selectedDispatchProcesses = [], mid) => {


        if (selectedDispatchProcesses.length > 0) {


            return selectedDispatchProcesses.map(process => ({
                marketId: process.marketId,
                ProcessData: process.ProcessData?.map(data => ({
                    ...data,
                    bulkId: bulkId,
                    DispatchText: data?.DispatchText || '',
                    PurposeofDispatch: data?.PurposeofDispatch || 'Customer Material',
                    DispatchDate: data?.DispatchDate || '',
                    DispatchSuggestionId: data?.DispatchSuggestionId || '',
                    DebitCreditWarehouseName: state?.selectedMarketData[0].wareHouseData[0]?._id || '',
                    DispatchModelTransport: data?.DispatchModelTransport || '',
                    DispatchRemarks: data?.DispatchRemarks || '',
                    DispatchDetails: data?.DispatchDetails?.map(detail => ({
                        ...detail,
                        DispatchCatogory: detail?.DispatchCatogory || '',
                        DispatchSubCatogory: detail?.DispatchSubCatogory || '',
                        DispatchProductName: detail?.DispatchProductName || '',
                        DispatchKitId: detail?.DispatchKitId || '',
                        DispatchDiscription: detail?.DispatchDiscription || '',
                        DispatchUnit: detail?.DispatchUnit || '',
                        DispatchQty: detail?.DispatchQty || ''
                    })) || [{
                        DispatchCatogory: '',
                        DispatchSubCatogory: '',
                        DispatchProductName: '',
                        DispatchKitId: '',
                        DispatchDiscription: '',
                        DispatchUnit: '',
                        DispatchQty: ''
                    }]
                })) || [{
                    DispatchText: '',
                    bulkId: bulkId,
                    PurposeofDispatch: 'Customer Material',
                    DispatchDate: '',
                    DispatchSuggestionId: '',
                    DebitCreditWarehouseName: state?.selectedMarketData[0].wareHouseData[0]?._id,
                    DispatchModelTransport: '',
                    DispatchRemarks: '',
                    DispatchDetails: [{
                        DispatchCatogory: '',
                        DispatchSubCatogory: '',
                        DispatchProductName: '',
                        DispatchDiscription: '',
                        DispatchUnit: '',
                        DispatchKitId: '',
                        DispatchQty: ''
                    }]
                }]
            }));
        }

        return mid.map(marketId => ({
            marketId,
            ProcessData: [{
                bulkId: bulkId,
                DispatchText: '',
                PurposeofDispatch: 'Customer Material',
                DispatchDate: '',
                DispatchSuggestionId: '',
                DebitCreditWarehouseName: state?.selectedMarketData[0].wareHouseData[0]?._id,
                DispatchModelTransport: '',
                DispatchRemarks: '',
                DispatchDetails: [{
                    DispatchCatogory: '',
                    DispatchSubCatogory: '',
                    DispatchProductName: '',
                    DispatchDiscription: '',
                    DispatchUnit: '',
                    DispatchKitId: '',
                    DispatchQty: ''
                }]
            }]
        }));
    };

    const initialValues = getInitialValues(selectedDispatchProcesses, mid);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchemas,
        onSubmit: handleSubmit,
    });
    const { handleBlur, handleChange, values, touched, errors, setFieldValue, resetForm, setValues } = formik;



    useEffect(() => {
        if (processData.length > 0) {
            setValues({ ...initialValues, ProcessData: processData });
        }
    }, [processData]);

    const [kitIdS, setKitIdS] = useState('');

    useEffect(() => {
        if (kitIdS) {
            checkKitAvailability(kitIdS)
        }

    }, [dispatch])

    const [kitAvaStatus, setKitAvaStatus] = useState('');


    const getAvailableQty = (selectedWarehouse, selectedProduct) => {
        const warehouseData = storeData.filter(store => store.warehouseId === selectedWarehouse);

        const productData = warehouseData?.flatMap(v => {
            return v?.multipleQty?.filter(qty => qty?.productName === selectedProduct);
        });

        const avlQty = productData?.reduce((acc, v) => acc + v.recieveQty, 0)




        return avlQty;


        // const matchingPurchases = purchase?.filter(purchase =>
        //     purchase.purchaseDetails?.some(pd =>
        //         pd.warehouseId === selectedWarehouse &&
        //         pd.multipleQty?.some(item => item.productName === selectedProduct)
        //     )
        // );







        // const totalQty = matchingPurchases.reduce((sum, purchase) => {
        //     const totalFromDetails = purchase.purchaseDetails?.reduce((detailSum, detail) => {
        //         if (detail.warehouseId === selectedWarehouse) {
        //             const productItems = detail.multipleQty.filter(item =>
        //                 item.productName === selectedProduct
        //             );


        //             return detailSum + productItems.reduce((itemSum, item) =>
        //                 itemSum + (parseInt(item.recieveQty) || 0), 0
        //             );
        //         }

        //         return detailSum;
        //     }, 0) || 0;
        //     return sum + totalFromDetails;
        // }, 0);

        // return totalQty;
    };

    const checkKitAvailability = (kitId) => {



        let selectedWarehouse = state?.selectedMarketData[0].wareHouseData[0]?._id;
        const kit = kitproductdata.find(kit => kit._id === kitId); // Find the specific kit by kitId

        if (!kit) {

            return { KitName: null, Status: "Kit not found" };
        }

        let isAvailable = true;

        for (let item of kit.KitDetails) {
            const availableQty = getAvailableQty(selectedWarehouse, item.KitProductName);




            if (availableQty < parseInt(item.KitQty)) {
                isAvailable = false;
                break;
            }
        }

        const status = {
            KitName: kit.KitName,
            Status: isAvailable ? "Available all" : "Some are not available"
        };





        setKitAvaStatus(status)
        // return status
    };



    const handleDispatchSuggestion = (event, index, midIndex, field, Market) => {
        const { name, value } = event.target;

        setFieldValue(name, value);

        const selectedSuggestion = suggestiondata.find(suggestion => suggestion._id === value);

        if (selectedSuggestion) {
            let updatedDetails = [...(selectedSuggestion.DispatchDetails || [])];

            updatedDetails.forEach(detail => {
                if (detail.DispatchCatogory === kitCategoryId &&
                    detail.DispatchSubCatogory === kitSubCategoryId) {
                    checkKitAvailability(detail.DispatchProductName);
                }
            });




            const indexProduct = updatedDetails.findIndex(detail =>
                detail.DispatchCatogory.trim() === "6749c8c7864db29472435057"
            );

            const isDisabledSolarPV = AlldispatchProcess?.find(v => v.marketId === Market?._id)?.ProcessData?.some((v) =>
                v?.DispatchDetails?.some((v1) =>
                    (v1.DispatchCatogory === "6749c8c7864db29472435057")
                )
            );

            let sum = 0;

            AlldispatchProcess?.find(v => v.marketId === Market?._id)?.ProcessData?.forEach((v) => {
                if (v?.PurposeofDispatch === 'Customer Material') {
                    const x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8c7864db29472435057");
                    if (x) {
                        sum += parseInt(x?.DispatchQty);
                    }
                }
            });

            const iPV = updatedDetails.findIndex((v) => v.DispatchCatogory === Market?.productData?.[0]?.mainCategory);

            if ((iPV !== -1) && isDisabledSolarPV && sum >= parseInt(Market?.SolarModuleNos)) {
                updatedDetails.splice(iPV, 1);
            } else {
                if (iPV !== -1) {
                    updatedDetails[iPV] = {
                        DispatchCatogory: Market.productData?.[0].mainCategory,
                        DispatchSubCatogory: Market.productData?.[0].subCategory,
                        DispatchProductName: Market.productData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.productData?.[0].Desacription,
                        DispatchUnit: Market.productData?.[0].unitOfMeasurement,
                        DispatchQty: Market.SolarModuleNos,
                    };
                } else if (indexProduct >= 0) {
                    updatedDetails[indexProduct] = {
                        DispatchCatogory: Market.productData?.[0].mainCategory,
                        DispatchSubCatogory: Market.productData?.[0].subCategory,
                        DispatchProductName: Market.productData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.productData?.[0].Desacription,
                        DispatchUnit: Market.productData?.[0].unitOfMeasurement,
                        DispatchQty: '',
                    };
                }
            }

            const indexInverter = updatedDetails.findIndex(detail => detail.DispatchCatogory === "6749c8bf864db29472435052");
            const isDisabledInverter = AlldispatchProcess?.find(v => v.marketId === Market?._id)?.ProcessData?.some((v) =>
                v?.DispatchDetails?.some((v1) =>
                    (v1.DispatchCatogory === "6749c8bf864db29472435052")
                )
            );

            const iIN = updatedDetails.findIndex((v) => v.DispatchCatogory === Market?.inverterData?.[0]?.mainCategory);

            if ((iIN !== -1) && isDisabledInverter) {
                updatedDetails.splice(iIN, 1);
            } else {
                if (indexInverter >= 0) {
                    updatedDetails[indexInverter] = {
                        DispatchCatogory: Market.inverterData?.[0].mainCategory,
                        DispatchSubCatogory: Market.inverterData?.[0].subCategory,
                        DispatchProductName: Market.inverterData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.inverterData?.[0].Desacription,
                        DispatchUnit: Market.inverterData?.[0].unitOfMeasurement,
                        DispatchQty: Market.MarketingType === 'Residential' ? 1 : '',
                    };
                }
            }



            // 

            setDispatchDetails(prevDetails => {
                const newDetails = [...prevDetails];
                newDetails[index] = updatedDetails;
                return newDetails;
            });

            setValues(prevValues => {
                const updatedValues = [...prevValues];
                updatedValues[midIndex].ProcessData[index][field] = value;
                return updatedValues;
            });
            setValues(prevValues => {
                const updatedValues = [...prevValues];
                updatedValues[midIndex].ProcessData[index].DispatchDetails = updatedDetails;
                return updatedValues;
            });

            setFieldValue(`ProcessData[${index}].DispatchDetails`, updatedDetails);
        }

        // setSelectedDispatchSuggestions(prev => {
        //     if (prev.includes(value)) {
        //         return prev.filter(id => id !== value);
        //     } else {
        //         return [...prev, value];
        //     }
        // });

        setValues(prevValues => {
            const updatedValues = [...prevValues];
            updatedValues[midIndex].ProcessData[index][field] = value;
            return updatedValues;
        });

        setBulkDispatch(prevDetails => {
            const newDetails = [...prevDetails];
            if (!newDetails[index]) {
                newDetails[index] = {};
            }
            newDetails[index] = { ...newDetails[index], [field]: value };
            return newDetails;
        });
    };




    const MemoizedTableRow = React.memo(({ detail, processIndex, index, i, d, isKit, kitData, midIndex, MarketData }) => {
        // 

        console.log("MarketDataMarketData", MarketData);


        return (
            <TableRow key={index}>
                <TableCell>{index + 1} .</TableCell>
                <TableCell sx={{ width: '8px' }}>
                    <TextField
                        margin="dense"
                        select
                        sx={{
                            width: {
                                xs: "160px",
                                sm: "180px",
                                md: "230px",
                            },
                            height: '40px',
                            "& .MuiInputBase-root": {

                                fontSize: "0.8rem",
                                height: "40px",
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 12px",
                                height: "40px",
                                lineHeight: "40px",
                            },
                        }}
                        variant="filled"
                        onBlur={handleBlur}
                        disabled={d}
                        name={`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchCatogory`}
                        // value={detail.DispatchCatogory || ''}
                        value={
                            isKit
                                ? kitCategoryId // Use kitCategoryId if it's a kit
                                : detail.DispatchCatogory || ''
                        }
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (values?.[midIndex]?.ProcessData?.[i]?.DispatchDetails?.[index]) {
                                setValues(prevValues => {
                                    const updatedValues = [...prevValues];
                                    updatedValues[midIndex] = {
                                        ...updatedValues[midIndex],
                                        ProcessData: updatedValues[midIndex].ProcessData.map((process, processIndex) => {
                                            if (processIndex === i) {
                                                return {
                                                    ...process,
                                                    DispatchDetails: process.DispatchDetails.map((detail, detailIndex) => {
                                                        if (detailIndex === index) {
                                                            return {
                                                                ...detail,
                                                                DispatchCatogory: newValue,
                                                                DispatchSubCatogory: '',
                                                                DispatchProductName: ''
                                                            };
                                                        }
                                                        return detail;
                                                    })
                                                };
                                            }
                                            return process;
                                        })
                                    };
                                    return updatedValues;
                                });
                            }
                        }}
                        error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory)}
                        helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory}
                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                    >
                        {
                            isKit ? (
                                <MenuItem value={kitCategoryId}>
                                    {categories.find(cat => cat._id === kitCategoryId)?.categoryName}
                                </MenuItem>
                            ) :
                                categories?.map((category) => {
                                    const isDisabled = AlldispatchProcess?.find(v => v.marketId === MarketData?._id)
                                        ?.ProcessData?.some((v) =>
                                            v?.DispatchDetails.some((v1) =>
                                                (v1.DispatchCatogory === MarketData?.inverterData?.[0]?.mainCategory &&
                                                    category._id === MarketData?.inverterData?.[0]?.mainCategory &&
                                                    MarketData?.MarketingType !== 'Commercial') ||
                                                (v1.DispatchCatogory === MarketData?.productData?.[0]?.mainCategory && category._id === MarketData?.productData?.[0]?.mainCategory)
                                            )
                                        );

                                    let sum = 0;

                                    AlldispatchProcess?.find(v => v.marketId === MarketData?._id)
                                        ?.ProcessData?.map((v) => {

                                            if (v?.PurposeofDispatch === 'Customer Material') {
                                                let x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === MarketData?.productData[0]?.mainCategory);



                                                if (x) {
                                                    sum = sum + parseInt(x?.DispatchQty)
                                                }

                                            }
                                        })






                                    return (
                                        <MenuItem key={category._id} value={category._id} disabled={values[midIndex].ProcessData[i]?.PurposeofDispatch === 'Return Material' || (sum < parseInt(MarketData?.SolarModuleNos) && category._id != MarketData?.inverterData?.[0]?.mainCategory) ? false : isDisabled}>
                                            {category.categoryName}
                                        </MenuItem>
                                    );
                                })}
                    </TextField>
                </TableCell>
                <TableCell sx={{ width: '8px' }}>
                    <TextField
                        disabled={d}
                        margin="dense"
                        // label="Sub Category :"
                        select
                        sx={{
                            width: {
                                xs: "160px",
                                sm: "180px",
                                md: "230px",
                            },
                            height: '40px',
                            "& .MuiInputBase-root": {

                                fontSize: "0.8rem",
                                height: "40px",
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 12px",
                                height: "40px",
                                lineHeight: "40px",
                            },
                        }}
                        variant="filled"
                        onBlur={handleBlur}
                        name={`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchSubCatogory`}
                        // value={detail.DispatchSubCatogory || ''}
                        value={
                            isKit
                                ? kitCategoryId // Use kitCategoryId if it's a kit
                                : detail.DispatchSubCatogory || ''
                        }
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (values?.[midIndex]?.ProcessData?.[i]?.DispatchDetails?.[index]) {
                                setValues(prevValues => {
                                    const updatedValues = [...prevValues];
                                    updatedValues[midIndex] = {
                                        ...updatedValues[midIndex],
                                        ProcessData: updatedValues[midIndex].ProcessData.map((process, processIndex) => {
                                            if (processIndex === i) {
                                                return {
                                                    ...process,
                                                    DispatchDetails: process.DispatchDetails.map((detail, detailIndex) => {
                                                        if (detailIndex === index) {
                                                            return {
                                                                ...detail,
                                                                DispatchSubCatogory: newValue,
                                                                DispatchProductName: ''
                                                            };
                                                        }
                                                        return detail;
                                                    })
                                                };
                                            }
                                            return process;
                                        })
                                    };
                                    return updatedValues;
                                });
                            }
                        }}
                        error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory)}
                        helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory}
                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                    >
                        {
                            isKit ? (
                                <MenuItem value={kitCategoryId}>
                                    {subcategories?.find(cat => cat._id === kitSubCategoryId)?.subCategoryName}
                                </MenuItem>
                            ) :

                                getFilteredSubcategories(detail.DispatchCatogory)?.data?.map(sub => {
                                    let sum = 0;

                                    // 


                                    const isDisabled = AlldispatchProcess?.find(v => v.marketId === MarketData?._id)?.ProcessData?.some((v) =>
                                        v?.DispatchDetails.some((v1) =>
                                            (v1.DispatchSubCatogory === MarketData?.inverterData?.[0]?.subCategory && sub._id === MarketData?.inverterData?.[0]?.subCategory) ||
                                            (v1.DispatchSubCatogory === MarketData?.productData?.[0]?.subCategory && sub._id === MarketData?.productData?.[0]?.subCategory)
                                        )
                                    );




                                    AlldispatchProcess?.find(v => v.marketId === MarketData?._id)?.ProcessData?.map((v) => {

                                        if (v?.PurposeofDispatch === 'Customer Material') {
                                            let x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === MarketData?.productData[0]?.mainCategory);



                                            if (x) {
                                                sum = sum + parseInt(x?.DispatchQty)
                                            }

                                        }
                                    })





                                    return (
                                        <MenuItem key={sub._id} value={sub._id}
                                            disabled={
                                                values[midIndex]?.ProcessData[i]?.PurposeofDispatch === 'Return Material'
                                                    ? false
                                                    : (
                                                        (detail.DispatchCatogory === MarketData?.productData?.[0]?.mainCategory &&
                                                            sub._id !== MarketData?.productData?.[0]?.subCategory) ||
                                                        (detail.DispatchCatogory === MarketData?.inverterData?.[0]?.mainCategory &&
                                                            sub._id !== MarketData?.inverterData?.[0]?.subCategory) ||
                                                        (!MarketData?.productData?.length && !MarketData?.inverterData?.length) || // Prevent accessing empty arrays
                                                        (detail.DispatchCatogory !== MarketData?.productData?.[0]?.mainCategory &&
                                                            detail.DispatchCatogory !== MarketData?.inverterData?.[0]?.mainCategory &&
                                                            isDisabled)
                                                    )
                                            }>
                                            {sub.subCategoryName}
                                        </MenuItem>

                                    )

                                })}
                    </TextField>
                </TableCell>

                {/* Product Name */}
                <TableCell sx={{ width: '10px' }}>
                    {values[midIndex].ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values[midIndex].ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                        <TextField
                            disabled={d}
                            margin="dense"
                            label="Kit Name :"
                            variant="filled"
                            select
                            fullWidth
                            sx={{
                                width: {
                                    xs: "180px",
                                    sm: "200px",
                                    md: "250px",
                                },
                                height: '40px',
                                "& .MuiInputBase-root": {
                                    fontSize: "0.8rem",
                                    height: "40px",
                                },
                                "& .MuiInputBase-input": {
                                    padding: "0 12px",
                                    height: "40px",
                                    lineHeight: "40px",
                                },
                            }}
                            name={`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchKitId`}


                            // onChange={(e) => {
                            //     const newValue = e.target.value;

                            //     // Set DispatchKitId and DispatchProductName
                            //     setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchQty`, "22");
                            //     setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`, newValue);

                            //     // Find selected kit
                            //     const selectedKit = kitproductdata.find(kit => kit._id === newValue);

                            //     

                            //     checkKitAvailability(selectedKit?._id);

                            //     if (selectedKit) {
                            //         
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchQty`, "22");
                            //         // Set DispatchKitDetails directly
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchKitDetails`, selectedKit.KitDetails);
                            //     } else {
                            //         

                            //         // Clear all fields if no kit is selected
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchKitId`, '');
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`, '');
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchDiscription`, '');
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchUnit`, '');
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchQty`, '');
                            //         setFieldValue(`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchKitDetails`, []);
                            //     }
                            // }}

                            onChange={(e) => {
                                const newValue = e.target.value;

                                const selectedKit = kitproductdata.find(kit => kit._id === newValue);



                                checkKitAvailability(selectedKit?._id);

                                setValues(prevValues => {
                                    return prevValues.map((item, idx) => {
                                        if (idx === midIndex) {
                                            return {
                                                ...item,
                                                ProcessData: item.ProcessData.map((process, pIdx) => {
                                                    if (pIdx === i) {
                                                        return {
                                                            ...process,
                                                            DispatchDetails: process.DispatchDetails.map((dispatch, dIdx) => {
                                                                if (dIdx === index) {
                                                                    return {
                                                                        ...dispatch,
                                                                        DispatchKitId: newValue,
                                                                        DispatchProductName: newValue,
                                                                        DispatchKitDetails: selectedKit ? selectedKit.KitDetails : [],
                                                                        DispatchQty: selectedKit?.KitDetails[0]?.KitQty || "",
                                                                    };
                                                                }
                                                                return dispatch;
                                                            })
                                                        };
                                                    }
                                                    return process;
                                                })
                                            };
                                        }
                                        return item;
                                    });
                                });
                            }}

                            // onChange={(e) => {
                            //     const newValue = e.target.value;
                            //     setValues(prevValues => {
                            //         const updatedValues = [...prevValues];
                            //         updatedValues[midIndex].ProcessData[i].DispatchDetails[index].DispatchProductName = newValue;
                            //         return updatedValues;
                            //     });
                            // }}

                            // value={detail.DispatchKitId || detail.DispatchProductName || ''}
                            value={
                                isKit && d
                                    ? kitData?.KitName // Use kitCategoryId if it's a kit
                                    : detail.DispatchKitId || detail.DispatchProductName || ''
                            }
                            InputLabelProps={{
                                style: {
                                    color: theme.palette.text.primary,
                                },
                            }}
                        >
                            {kitproductdata ? kitproductdata.map(kit => (
                                <MenuItem key={kit._id} value={kit._id}>
                                    {kit.KitName}
                                </MenuItem>
                            )) : null}
                        </TextField>



                    ) : (
                        <TextField
                            disabled={d}
                            margin="dense"
                            // label="Product Name : "
                            variant="filled"
                            sx={{
                                width: {
                                    xs: "180px",
                                    sm: "200px",
                                    md: "250px",
                                },
                                height: '40px',
                                "& .MuiInputBase-root": {
                                    fontSize: "0.8rem",
                                    height: "40px",
                                },
                                "& .MuiInputBase-input": {
                                    padding: "0 12px",
                                    height: "40px",
                                    lineHeight: "40px",
                                },
                            }}
                            select
                            // value={detail.DispatchProductName || ''}
                            value={
                                isKit && d
                                    ? kitData?._id // Use kitCategoryId if it's a kit
                                    : detail.DispatchKitId || detail.DispatchProductName || ''
                            }
                            name={`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`}
                            fullWidth
                            onBlur={handleBlur}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                if (values?.[midIndex]?.ProcessData?.[i]?.DispatchDetails?.[index]) {
                                    const selectedProduct = products.find(prod => prod._id === newValue);

                                    setValues(prevValues => {
                                        return prevValues.map((item, idx) => {
                                            if (idx === midIndex) {
                                                return {
                                                    ...item,
                                                    ProcessData: item.ProcessData.map((process, pIdx) => {
                                                        if (pIdx === i) {
                                                            return {
                                                                ...process,
                                                                DispatchDetails: process.DispatchDetails.map((dispatch, dIdx) => {
                                                                    if (dIdx === index) {
                                                                        return {
                                                                            ...dispatch,
                                                                            DispatchProductName: newValue,
                                                                            DispatchDiscription: selectedProduct?.Desacription || '',
                                                                            DispatchUnit: selectedProduct?.unitOfMeasurement || ''
                                                                        };
                                                                    }
                                                                    return dispatch;
                                                                })
                                                            };
                                                        }
                                                        return process;
                                                    })
                                                };
                                            }
                                            return item;
                                        });
                                    });
                                }
                            }}

                            error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName)}
                            helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName}
                            InputLabelProps={{
                                style: {
                                    color: theme.palette.text.primary
                                }
                            }}
                        >
                            {
                                isKit && d ? (
                                    <MenuItem value={kitData?._id}>
                                        {kitData?.KitName}
                                    </MenuItem>
                                ) :

                                    getFilteredProducts(detail.DispatchCatogory, detail.DispatchSubCatogory, MarketData)?.data?.map(prod => {


                                        let sum = 0;
                                        let isDisabled;




                                        if (AlldispatchProcess) {


                                            isDisabled = AlldispatchProcess?.find(v => v.marketId === MarketData?._id)?.ProcessData?.some((v) =>
                                                v?.DispatchDetails.some((v1) =>
                                                    (v1.DispatchProductName === MarketData?.inverterData[0]?._id
                                                        && prod._id === MarketData?.inverterData[0]?._id
                                                    ) ||
                                                    (v1.DispatchProductName === MarketData?.productData[0]?._id
                                                        && prod._id === MarketData?.productData[0]?._id
                                                    )
                                                )
                                            );


                                        } else if (prod?._id === MarketData?.productData[0]?._id || prod?._id === MarketData?.inverterData[0]?._id) {

                                            isDisabled = false
                                        } else {
                                            if (prod.mainCategory === "6749c8c7864db29472435057" || prod.mainCategory === '6749c8bf864db29472435052') {
                                                isDisabled = true
                                            } else {
                                                isDisabled = false
                                            }


                                        }





                                        AlldispatchProcess?.find(v => v.marketId === MarketData?._id)?.ProcessData?.map((v) => {

                                            if (v?.PurposeofDispatch === 'Customer Material') {
                                                let x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === MarketData?.productData[0]?.mainCategory);



                                                if (x) {
                                                    sum = sum + parseInt(x?.DispatchQty)
                                                }

                                            }
                                        })




                                        return (
                                            <MenuItem
                                                key={prod._id}
                                                value={prod._id}
                                                disabled={
                                                    // Always enabled for Return Material
                                                    values[midIndex]?.ProcessData?.[i]?.PurposeofDispatch === 'Return Material' ||
                                                        (MarketData?.productData?.length > 0 &&
                                                            detail.DispatchCatogory === MarketData?.productData?.[0]?.mainCategory &&
                                                            (sum <= parseInt(MarketData?.SolarModuleNos) && prod._id === MarketData?.productData?.[0]?._id))
                                                        ? false
                                                        : (
                                                            // Check if product doesn't match selected category/subcategory
                                                            prod.mainCategory !== detail.DispatchCatogory ||
                                                            prod.subCategory !== detail.DispatchSubCatogory ||

                                                            // If PV/Inverter category, only allow MarketData's specific product
                                                            (MarketData?.productData?.length > 0 &&
                                                                detail.DispatchCatogory === MarketData?.productData?.[0]?.mainCategory &&
                                                                prod._id !== MarketData?.productData?.[0]?._id) ||
                                                            (MarketData?.inverterData?.length > 0 &&
                                                                detail.DispatchCatogory === MarketData?.inverterData?.[0]?.mainCategory &&
                                                                prod._id !== MarketData?.inverterData?.[0]?._id)
                                                        )
                                                }
                                            >
                                                {prod.productName}
                                            </MenuItem>

                                        )
                                    })
                            }
                        </TextField>
                    )}
                </TableCell>
                <TableCell sx={{ width: '10px' }}>
                    {
                        values[midIndex].ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                            values[midIndex].ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                            ''
                        ) : d && isKit ? ''
                            : (
                                <TextField
                                    disabled={d}
                                    margin="dense"
                                    // label="Description : "
                                    sx={{
                                        width: {
                                            xs: "180px",
                                            sm: "200px",
                                            md: "250px",
                                        },
                                        height: '40px',
                                        "& .MuiInputBase-root": {
                                            fontSize: "0.8rem",
                                            height: "40px",
                                        },
                                        "& .MuiInputBase-input": {
                                            padding: "0 12px",
                                            height: "40px",
                                            lineHeight: "40px",
                                        },
                                    }}
                                    variant="filled"
                                    fullWidth
                                    value={products?.find(prod => prod._id === detail.DispatchProductName)?.Desacription || ''}
                                    InputLabelProps={{
                                        shrink: true,
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            )}
                </TableCell>
                <TableCell sx={{ width: '10px' }}>
                    {values[midIndex].ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values[midIndex].ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                        ''
                    ) : d && isKit ? ''
                        : (
                            <TextField
                                disabled={d}
                                margin="dense"
                                // label="Unit : "
                                variant="filled"
                                name={`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchUnit`}
                                fullWidth
                                sx={{
                                    width: {
                                        xs: "80px",
                                        sm: "80px",
                                        md: "80px",
                                    },
                                    height: '40px',
                                    "& .MuiInputBase-root": {
                                        fontSize: "0.8rem",
                                        height: "40px",
                                    },
                                    "& .MuiInputBase-input": {
                                        padding: "0 12px",
                                        height: "40px",
                                        lineHeight: "40px",
                                    },
                                }}
                                value={products?.find(prod => prod._id === detail.DispatchProductName)?.unitOfMeasurement || ''}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        )}
                </TableCell>
                <TableCell sx={{ width: '10px', paddingTop: '30px' }}>
                    {values[midIndex].ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values[midIndex].ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                        <>
                            {kitAvaStatus?.Status}
                        </>
                    ) : d && isKit ? '1'
                        : (
                            // <TextField
                            //     disabled={d}
                            //     margin="dense"
                            //     // label="Quantity : "
                            //     variant="filled"
                            //     fullWidth
                            //     value={detail.DispatchQty}
                            //     name={`values[${midIndex}].ProcessData[${i}].DispatchDetails[${index}].DispatchQty`}
                            //     InputLabelProps={{
                            //         shrink: true,
                            //         style: {
                            //             color: theme.palette.text.primary
                            //         }
                            //     }}
                            //     sx={{
                            //         width: {
                            //             xs: "100px",
                            //             sm: "100px",
                            //             md: "100px",
                            //         },
                            //         height: '40px',
                            //         "& .MuiInputBase-root": {
                            //             fontSize: "0.8rem",
                            //             height: "40px",
                            //         },
                            //         "& .MuiInputBase-input": {
                            //             padding: "0 12px",
                            //             height: "40px",
                            //             lineHeight: "40px",
                            //         },
                            //     }}
                            //     onBlur={handleBlur}
                            //     onChange={(e) => {
                            //         const updatedQty = e.target.value;
                            //         if (values?.[midIndex]?.ProcessData?.[i]?.DispatchDetails?.[index]) {
                            //             setValues(prevValues => {
                            //                 const updatedValues = [...prevValues];
                            //                 updatedValues[midIndex] = {
                            //                     ...updatedValues[midIndex],
                            //                     ProcessData: updatedValues[midIndex].ProcessData.map((process, processIndex) => {
                            //                         if (processIndex === i) {
                            //                             return {
                            //                                 ...process,
                            //                                 DispatchDetails: process.DispatchDetails.map((detail, detailIndex) => {
                            //                                     if (detailIndex === index) {
                            //                                         return {
                            //                                             ...detail,
                            //                                             DispatchQty: updatedQty
                            //                                         };
                            //                                     }
                            //                                     return detail;
                            //                                 })
                            //                             };
                            //                         }
                            //                         return process;
                            //                     })
                            //                 };
                            //                 return updatedValues;
                            //             });
                            //         }
                            //     }}
                            //     error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty)}
                            //     helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty}
                            // />

                            <QtyInputNested
                                midIndex={midIndex}
                                i={i}
                                index={index}
                                detail={detail} // Pass the individual detail object
                                d={d}
                                theme={theme}
                                values={values} // Pass the full form values
                                setValues={setValues} // Pass the setValues function
                                handleBlur={handleBlur} // Pass your handleBlur function
                                touched={touched} // Pass the touched state
                                errors={errors} // Pass the errors state
                            />
                        )}
                    {values[midIndex].ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values[midIndex].ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? '' :
                        d ? '' :
                            <Typography variant="body2" color="textSecondary">
                                {
                                    MarketData && MarketData.wareHouseData?.length > 0 ? (
                                        <>
                                            Available Qty: {getAvailableQty(
                                                MarketData?.wareHouseData[0]?._id || '',
                                                values?.[midIndex]?.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName || ''
                                            )}
                                        </>
                                    ) : null
                                }


                            </Typography>}
                </TableCell>
                <TableCell>
                    <Stack spacing={2} direction="row">
                        <Button
                            disabled={d}
                            variant="contained"
                            color="success"
                            onClick={() => handleBulkDispatch1(midIndex, i, index)}
                            sx={{
                                width: "35px",
                                height: "35px",
                                minWidth: "20px",
                                padding: "0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <AddIcon sx={{ fontSize: "16px" }} />
                        </Button>
                        {(!AlldispatchProcess?.find(v => v.marketId === MarketData?._id)?.ProcessData?.some(process => process.DispatchDetails.includes(detail))) && (
                            <Button
                                variant="contained"
                                color="error"
                                disabled={d}
                                onClick={() => handleBulkDelete(midIndex, i, index)}
                                sx={{
                                    width: "35px",
                                    height: "35px",
                                    minWidth: "20px",
                                    padding: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <DeleteIcon sx={{ fontSize: "16px" }} />
                            </Button>
                        )}
                    </Stack>
                </TableCell>
            </TableRow>
        );
    });

    const handleAddDispatchDetail = (midIndex, processIndex) => {
        const newDetail = {
            DispatchCatogory: '',
            DispatchSubCatogory: '',
            DispatchProductName: '',
            DispatchDiscription: '',
            DispatchUnit: '',
            DispatchQty: '',
        };

        if (!values[midIndex].ProcessData[processIndex].DispatchDetails) {
            values[midIndex].ProcessData[processIndex].DispatchDetails = [];
        }
        values[midIndex].ProcessData[processIndex].DispatchDetails.push(newDetail);
        setValues([...values]);
    };

    const handleAddProcess = (mid) => {
        const newProcess = {
            DispatchText: '',
            PurposeofDispatch: 'Customer Material',
            DispatchSuggestionId: '',
            DispatchModelTransport: '',
            DispatchRemarks: '',
            DispatchDate: '',
            DebitCreditWarehouseName: state?.selectedMarketData[0].wareHouseData[0]?._id,
        };
        const updatedData = [...(values?.map(p => p.marketId === mid ? { ...p, ProcessData: [...p.ProcessData, newProcess] } : p))];
        setValues(updatedData);
    };

    const handleDispatchDetailChange = (midIndex, processIndex, field, value) => {
        setValues(prevValues => {
            const updatedValues = [...prevValues];
            updatedValues[midIndex].ProcessData[processIndex][field] = value;

            if (field === 'DispatchKitId') {
                const selectedKit = kitproductdata.find(kit => kit._id === value);
                if (selectedKit) {
                    updatedValues[midIndex].ProcessData[processIndex].DispatchProductName = selectedKit.KitProductName || null;
                } else {
                    updatedValues[midIndex].ProcessData[processIndex].DispatchProductName = null;
                }
            }
            return updatedValues;
        });
    };

    const getFilteredSubcategories = (categoryId) => {

        const isDisabled =
            categoryId === Market?.productData?.[0]?.mainCategory ||
            categoryId === Market?.inverterData?.[0]?.mainCategory;




        return { data: subcategories?.filter(sub => sub.categoryData?.[0]?._id === categoryId), isDisabled };
    };


    const getFilteredProducts = useCallback((categoryId, subcategoryId, MarketData) => {
        const isDisabled =
            categoryId === MarketData?.productData?.[0]?.mainCategory ||
            categoryId === MarketData?.inverterData?.[0]?.mainCategory;

        return {
            data: products?.filter(product =>
                product.mainCategoryData?.[0]?._id === categoryId && product.subCategoryData?.[0]?._id === subcategoryId
            ),
            isDisabled
        };
    }, [products]);

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = (dispatchProcess) => {
        setDialogValues({
            DebitCreditWarehouseName: state?.selectedMarketData[0].wareHouseData[0]?._id || '',
            DispatchModelTransport: dispatchProcess?.DispatchModelTransport || '',
            DispatchRemarks: dispatchProcess?.DispatchRemarks || ''
        });
        setOpen(true);
    };

    const handleBulkDispatch1 = (midIndex, processIndex, detailIndex) => {
        const oldKitDetails = [...values];
        const newKit = {
            DispatchCatogory: '',
            DispatchSubCatogory: '',
            DispatchProductName: '',
            DispatchDiscription: '',
            DispatchUnit: '',
            DispatchQty: '',
        };

        const newdata = oldKitDetails[midIndex].ProcessData[processIndex].DispatchDetails.splice(detailIndex + 1, 0, newKit);
        setDispatchDetails(newdata);
        setFieldValue(newdata)
    };

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);

    const handleBulkDelete = (midIndex, processIndex, detailIndex) => {
        const detailToDelete = {
            midIndex,
            processIndex,
            detailIndex
        };
        setSelectedDetail(detailToDelete);
        setOpenConfirmDialog(true);
    };
    const handleDeleteConfirm = (detail) => {
        const { midIndex, processIndex, detailIndex } = detail;
        const oldKitDetails = [...values];
        oldKitDetails[midIndex].ProcessData[processIndex].DispatchDetails.splice(detailIndex, 1);
        setValues(oldKitDetails);
        setOpenConfirmDialog(false);
    };

    const [openDialog, setOpenDialog] = useState(false);
    const [BulkData, setBulkData] = useState(false);

    const orderDetails = {
        billTo: {
            companyName: 'Tvarit Energy LLP.',
            address: '707 - Twin Star, North Block, Near Nana Mava Circle, 150 Ft Ring Road, Rajkot, Gujarat - 360005',
            gst: '24AAQFT9592E1ZK',
            contactNumber: '+91 97245 71843',
            email: 'info@tvaritenergy.in',
            website: 'www.tvaritenergy.in',
        },
    };

    const handlePrint = (mid) => {
        const showsameData = mid.map((id) => AlldispatchProcess.find(i => i.marketId === id)).filter(data => data);

        // 

        const storedBulkId = localStorage.getItem("bulkId");

        const filteredData = showsameData.filter(item => {
            // Check if ProcessData array exists and is not empty
            if (item.ProcessData && item.ProcessData.length > 0) {
                // Check if any ProcessData object has a matching bulkId
                return item.ProcessData.some(process => process.bulkId === storedBulkId);
            }
            return false; // If no ProcessData or empty array, exclude the item
        });




        setBulkData(filteredData);
        setOpenDialog(true);
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleAddKit1 = (processIndex, detailIndex, index) => {


        const oldKitDetails = [...values.ProcessData[processIndex].DispatchDetails];
        const newKit = {
            DispatchCatogory: '',
            DispatchSubCatogory: '',
            DispatchProductName: '',
            DispatchDiscription: '',
            DispatchUnit: '',
            DispatchQty: '',
        };

        oldKitDetails.splice(detailIndex + 1, 0, newKit);
        setDispatchDetails(prevDetails => {
            const newDetails = [...prevDetails];
            newDetails[processIndex] = oldKitDetails;
            return newDetails;
        });
        setFieldValue(`ProcessData[${processIndex}].DispatchDetails`, oldKitDetails);
        formik.setTouched({
            ProcessData: oldKitDetails.map((_, i) => ({
                DispatchCatogory: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchCatogory,
                DispatchSubCatogory: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchSubCatogory,
                DispatchProductName: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchProductName,
                DispatchDiscription: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchDiscription,
                DispatchUnit: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchUnit,
                DispatchQty: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchQty,
            })),
        });
    };

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteItemIndex, setDeleteItemIndex] = useState(null);

    const handleOpenDeleteDialog = (processIndex, dispatchIndex) => {
        setDeleteItemIndex({ processIndex, dispatchIndex });
        setOpenDeleteDialog(true);
    };

    const generateProductRows = (processItem) => {


        if (!processItem?.DispatchDetails) return [];
        return processItem.DispatchDetails.map((item, DataIndex) => {
            // const product = item.DispatchProductNameData;
            const qty = item.DispatchQty || 0;

            const product = item?.KitNo === 0 ?
                item.DispatchProductNameData || 'N/A' :
                kitproductdata?.find((k) => k?._id === item.DispatchKitId)
                ;

            return [
                { text: (DataIndex + 1).toString(), fontSize: 9 },
                { text: product?.productName || product?.KitName || 'N/A', fontSize: 9 },
                { text: item?.KitNo === 0 ? item.DispatchDiscription || 'N/A' : 'N/A', fontSize: 9 },
                { text: item?.KitNo === 0 ? qty.toString() || 'N/A' : 1, fontSize: 9 },
            ];
        });
    };

    // const insufficientProducts = useMemo(() => {
    //     const grouped = {};
    //     const requiredQtyMap = new Map();

    //     values?.forEach((value) => {
    //         value?.ProcessData
    //             .filter(v => !v?.generatedNumber && v?.PurposeofDispatch === "Customer Material")
    //             .forEach((process) => {
    //                 process?.DispatchDetails?.forEach((detail) => {
    //                     const productName = detail?.DispatchProductName;
    //                     const kit = kitproductdata?.find(k => k._id === productName);
    //                     if (kit) {
    //                         kit?.KitDetails?.forEach(kitItem => {
    //                             const name = kitItem?.KitProductName;
    //                             const qty = parseInt(kitItem?.KitQty);
    //                             requiredQtyMap.set(name, (requiredQtyMap?.get(name) || 0) + qty);
    //                         });
    //                     } else {
    //                         requiredQtyMap.set(productName, (requiredQtyMap?.get(productName) || 0) + Number(detail.DispatchQty));
    //                     }
    //                 });
    //             });
    //     });

    //     const insufficient = new Set();

    //     requiredQtyMap.forEach((requiredQty, productId) => {
    //         const available = getAvailableQty(selectedMarketData[0]?.WarehouseId, productId);
    //         if (requiredQty > available) {
    //             insufficient.add(productId);
    //         }
    //     });

    //     return insufficient;
    // }, [values, selectedMarketData, kitproductdata]);

    const insufficientProducts = useMemo(() => {
        const requiredQtyMap = new Map();
        const dispatchedKitProductDetails = new Map(); // Map to store details of products that are part of dispatched kits
        const dispatchedStandaloneProducts = new Set(); // Set to store IDs of products dispatched as standalone items

        values?.forEach((value) => {
            value?.ProcessData
                .filter(v => !v?.generatedNumber && v?.PurposeofDispatch === "Customer Material")
                .forEach((process) => {
                    process?.DispatchDetails?.forEach((detail) => {
                        const productName = detail?.DispatchProductName;
                        const kit = kitproductdata?.find(k => k._id === productName);

                        if (kit) {
                            // If it's a kit, add its components to requiredQtyMap
                            // and track that these components are part of a kit dispatch.
                            kit?.KitDetails?.forEach(kitItem => {
                                const name = kitItem?.KitProductName;
                                const qty = parseInt(kitItem?.KitQty);
                                requiredQtyMap.set(name, (requiredQtyMap?.get(name) || 0) + qty);

                                // Store which kit this component belongs to
                                if (!dispatchedKitProductDetails.has(name)) {
                                    dispatchedKitProductDetails.set(name, new Set());
                                }
                                dispatchedKitProductDetails.get(name).add(kit._id);
                            });
                        } else {
                            // If it's a standalone product, add it to requiredQtyMap
                            // and mark it as a standalone dispatch.
                            requiredQtyMap.set(productName, (requiredQtyMap?.get(productName) || 0) + Number(detail.DispatchQty));
                            dispatchedStandaloneProducts.add(productName);
                        }
                    });
                });
        });

        const insufficient = new Set();
        const kitsWithInsufficientComponents = new Set();

        requiredQtyMap.forEach((requiredQty, productId) => {
            const available = getAvailableQty(selectedMarketData[0]?.WarehouseId, productId);

            if (requiredQty > available) {
                // Check if this product is part of any dispatched kits
                if (dispatchedKitProductDetails.has(productId)) {
                    // If it is, add all associated kit IDs to kitsWithInsufficientComponents
                    dispatchedKitProductDetails.get(productId).forEach(kitId => {
                        kitsWithInsufficientComponents.add(kitId);
                    });
                }

                // Only add the individual product ID to 'insufficient' if it was dispatched as a standalone item.
                if (dispatchedStandaloneProducts.has(productId)) {
                    insufficient.add(productId);
                }
            }
        });

        // Finally, add all kit IDs that have insufficient components to the 'insufficient' set.
        kitsWithInsufficientComponents.forEach(kitId => insufficient.add(kitId));

        return insufficient;
    }, [values, selectedMarketData, kitproductdata]);

    console.log("insufficientProducts", insufficientProducts);


    const generatePdfContentBulk = async (selectedPurchase, matchingDispatchProcess) => {
        // BulkData.map((data, index) => (
        //     <Box key={data._id}>
        //         {data.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"))?.map((process, index) 
        let xx = matchingDispatchProcess?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"));

        await getLexendFonts();

        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
            Lexend: {
                normal: 'Lexend-Regular.ttf',
                bold: 'Lexend-Bold.ttf',
            }
        };

        const logoSrc = theme.palette.mode === "dark" ? '../../assets/images/logo/logo.svg' : '../../assets/images/logo/logo.svg';
        const logoBase64 = await getBase64Image(logoSrc);
        const stampImg = await getBase64Image("../../assets/images/stamp/stamp.svg")
        const allPagesContent = [];



        // Check for bulk data
        const processbulkIds = AlldispatchProcess.find(process => process._id === dispatchProcessId);
        const bulkIds = processbulkIds?.ProcessData.map(p => p.bulkId).filter(Boolean);
        const bulkfiltered = AlldispatchProcess.filter(process =>
            process.ProcessData.some(data => bulkIds?.includes(data.bulkId))
        );

        if (BulkData) {
            if (BulkData.length > 0) {
                allPagesContent.push({ text: '', pageBreak: 'before' });
                allPagesContent.push(
                    {
                        columns: [
                            {
                                image: logoBase64,
                                width: 100,
                                margin: [0, 0, 0, 0]
                            },
                            // {
                            //     text: matchingDispatchProcess?.ProcessData?.[0]?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN',
                            //     style: 'header',
                            //     alignment: 'right',
                            //     margin: [0, 0, 0, 2],
                            //     decoration: 'underline',
                            //     decorationColor: '#FB9822'
                            // },
                        ],
                    }
                );
                allPagesContent.push({
                    text: 'Bulk Dispatch Details',
                    style: 'header',
                    margin: [0, 20, 0, 10]
                });

                {
                    const masterGrouped = {};
                    let totalQty = 0;



                    if (Array.isArray(BulkData)) {
                        BulkData.forEach(bulkItem => {
                            const FileNo = bulkItem.marketData?.fillNo || 'N/A';
                            const ConsumerName = bulkItem.marketData?.ConsumerName || 'N/A';
                            const matchingProcessData = bulkItem?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"));

                            matchingProcessData.forEach(detail => {
                                const displayedKits = new Set();

                                allPagesContent.push({
                                    text: `Details for ${detail.generatedNumber} - ${bulkItem?.marketData?.ConsumerName} (${bulkItem?.marketData?.fillNo}) ${format(new Date(detail.DispatchDate), 'dd-MM-yyyy')}`,
                                    style: 'subheader',
                                    margin: [0, 20, 0, 0],
                                    fontSize: 11,
                                });

                                detail?.DispatchDetails?.forEach(d => {
                                    let nameKey = 'N/A', category = 'N/A', subcategory = 'N/A', description = 'N/A', unit = 'N/A', qty = 1;

                                    if (d.KitNo === 0) {
                                        nameKey = d?.DispatchProductNameData?.productName || 'N/A';
                                        category = d?.DispatchCatogoryData?.categoryName || 'N/A';
                                        subcategory = d?.DispatchSubCatogoryData?.subCategoryName || 'N/A';
                                        description = d?.DispatchDiscription || 'N/A';
                                        unit = d?.DispatchUnit || 'N/A';
                                        qty = Number(d?.DispatchQty || 0);
                                    } else {
                                        if (displayedKits.has(d.DispatchKitId)) return;
                                        displayedKits.add(d.DispatchKitId);

                                        const kitProduct = kitproductdata?.find(k => k._id === detail.DispatchKitId);
                                        nameKey = kitProduct?.productName || kitProduct?.KitName || 'Kit Product';

                                        category = 'KitCategory';
                                        subcategory = 'KitSubCategory';
                                        qty = 1;
                                    }

                                    if (!masterGrouped[nameKey]) {
                                        masterGrouped[nameKey] = {
                                            totalQty: 0,
                                            category,
                                            subcategory,
                                            nameKey,
                                            description,
                                            unit,
                                            purposes: new Set(),
                                            fileNos: new Set(),
                                            consumerNames: new Set(),
                                        };
                                    }

                                    masterGrouped[nameKey].totalQty += qty;
                                    masterGrouped[nameKey].purposes.add(detail.PurposeofDispatch);
                                    masterGrouped[nameKey].fileNos.add(FileNo);
                                    masterGrouped[nameKey].consumerNames.add(ConsumerName);
                                    totalQty += qty;
                                });
                            });
                        });
                    }


                    console.log("masterGroupedmasterGrouped", masterGrouped);

                    const tableBody = [
                        [
                            { text: 'SR. NO.', style: 'tableHeader', border: [true, true, false, true], fontSize: 8, characterSpacing: 1 },
                            { text: 'PRODUCT NAME', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                            { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                            { text: 'QTY.', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                        ]
                    ];

                    Object.values(masterGrouped).forEach((item, index) => {
                        tableBody.push([
                            { text: (index + 1).toString(), fontSize: 9 },
                            { text: item.nameKey, fontSize: 9 },
                            { text: item.description || 'N/A', fontSize: 9 },
                            { text: item.totalQty.toString(), fontSize: 9 },
                        ]);
                    });

                    allPagesContent.push({
                        table: {
                            headerRows: 1,
                            widths: ['auto', '*', '*', 'auto'],
                            body: tableBody,
                        },
                        margin: [0, 15, 0, 0],
                    });

                    allPagesContent.push({
                        text: `Total Quantity: ${totalQty}`,
                        style: 'subheader',
                        margin: [0, 20, 0, 0],
                        fontSize: 11,
                    });



                    // BulkData?.length > 0 ? (
                    //     Array.isArray(BulkData) && BulkData.map((bulkItem, bulkIndex) => {
                    //         let dispatchDate = '';
                    //         const FileNo = bulkItem.marketData?.fillNo || 'N/A';
                    //         const ConsumerName = bulkItem.marketData?.ConsumerName || 'N/A';

                    //         const totalQty = BulkData.reduce((total, value) => {
                    //             const processData = value?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"));
                    //             const displayedKits = new Set(); // Declare once per item
                    //             return total + processData.reduce((processTotal, process) => {
                    //                 return processTotal + process?.DispatchDetails?.reduce((detailTotal, detail) => {
                    //                     if (detail?.KitNo !== 0) {
                    //                         if (displayedKits.has(detail.DispatchKitId)) return detailTotal;
                    //                         displayedKits.add(detail.DispatchKitId);
                    //                     }
                    //                     return detailTotal + Number(detail?.DispatchQty || 0);
                    //                 }, 0);
                    //             }, 0);
                    //         }, 0);

                    //         const matchingProcessData = bulkItem?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"));

                    //         return (
                    //             <Box key={bulkIndex} sx={{ padding: 2 }}>
                    //                 {matchingProcessData.map((detail, processIndex) => {
                    //                     const displayedKits = new Set();
                    //                     // const masterGrouped = {}; // define inside to reset for each dispatch

                    //                     // Grouping logic
                    //                     detail?.DispatchDetails?.forEach(d => {
                    //                         let nameKey = 'N/A', category = 'N/A', subcategory = 'N/A', description = 'N/A', unit = 'N/A', qty = 1;

                    //                         if (d.KitNo === 0) {
                    //                             nameKey = d?.DispatchProductNameData?.productName || 'N/A';
                    //                             category = d?.DispatchCatogoryData?.categoryName || 'N/A';
                    //                             subcategory = d?.DispatchSubCatogoryData?.subCategoryName || 'N/A';
                    //                             description = d?.DispatchDiscription || 'N/A';
                    //                             unit = d?.DispatchUnit || 'N/A';
                    //                             qty = Number(d?.DispatchQty || 0);
                    //                         } else {
                    //                             if (displayedKits.has(d.DispatchKitId)) return;
                    //                             displayedKits.add(d.DispatchKitId);

                    //                             const kitProduct = kitproductdata?.find(k => k._id === detail.DispatchKitId);
                    //                             nameKey = kitProduct?.productName || kitProduct?.KitName || 'Kit Product';


                    //                             category = 'KitCategory';
                    //                             subcategory = 'KitSubCategory';
                    //                             qty = 1;
                    //                         }

                    //                         console.log("nameKeynameKeynameKeynameKeys", nameKey);


                    //                         if (!masterGrouped[nameKey]) {
                    //                             masterGrouped[nameKey] = {
                    //                                 totalQty: 0,
                    //                                 category,
                    //                                 subcategory,
                    //                                 nameKey,
                    //                                 description,
                    //                                 unit,
                    //                                 purposes: new Set(),
                    //                                 fileNos: new Set(),
                    //                                 consumerNames: new Set(),
                    //                             };
                    //                         }

                    //                         masterGrouped[nameKey].totalQty += qty;
                    //                         masterGrouped[nameKey].purposes.add(detail.PurposeofDispatch);
                    //                         masterGrouped[nameKey].fileNos.add(FileNo);
                    //                         masterGrouped[nameKey].consumerNames.add(ConsumerName);
                    //                     });

                    //                     const tableBody = [
                    //                         [
                    //                             { text: 'SR. NO.', style: 'tableHeader', border: [true, true, false, true], fontSize: 8, characterSpacing: 1 },
                    //                             { text: 'PRODUCT NAME', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                    //                             { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                    //                             { text: 'QTY.', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                    //                         ]
                    //                     ];

                    //                     Object.values(masterGrouped).forEach((item, index) => {
                    //                         tableBody.push([
                    //                             { text: (index + 1).toString(), fontSize: 9 },
                    //                             { text: item.nameKey, fontSize: 9 },
                    //                             { text: item.description || 'N/A', fontSize: 9 },
                    //                             { text: item.totalQty.toString(), fontSize: 9 },
                    //                         ]);
                    //                     });

                    //                     allPagesContent.push({
                    //                         table: {
                    //                             headerRows: 1,
                    //                             widths: ['auto', '*', '*', 'auto'],
                    //                             body: tableBody,
                    //                         },
                    //                         margin: [0, 15, 0, 0],
                    //                     });

                    //                     if (bulkIndex === BulkData.length - 1 && processIndex === matchingProcessData.length - 1) {
                    //                         allPagesContent.push({
                    //                             text: `Total Quantity: ${totalQty}`,
                    //                             style: 'subheader',
                    //                             margin: [0, 20, 0, 0],
                    //                             fontSize: 11,
                    //                         });
                    //                     }

                    //                     return (
                    //                         <Box key={processIndex}>
                    //                             <Typography variant="h5" sx={{ marginBottom: 2 }}>
                    //                                 Bulk Dispatch Details for {detail.generatedNumber}
                    //                             </Typography>
                    //                         </Box>
                    //                     );
                    //                 })}
                    //             </Box>
                    //         );
                    //     })

                    // ) : (
                    //     <Typography variant="h6" color="textSecondary" align="center">
                    //         No Bulk Dispatch Data Available.
                    //     </Typography>
                    // )
                }
                allPagesContent.push({
                    width: '*',
                    stack: [
                        {
                            image: stampImg,
                            width: 150,
                            alignment: 'right'
                        },
                        {
                            text: 'Company Stamp & Sign',
                            alignment: 'right',
                            bold: true,
                            margin: [0, 5, 0, 0]
                        }
                    ],
                    margin: [0, 20, 0, 0] // Reduced stamp margin
                });
            }
        }
        const docDefinition = {
            content: allPagesContent,
            styles: {
                header: {
                    fontSize: 25,
                    bold: true,
                    color: '#1F2F58',
                    font: 'Lexend',
                },
                subheader: {
                    fontSize: 20,
                    bold: true,
                    margin: [0, 10, 0, 5],
                    font: 'Lexend',
                },
                tableHeader: {
                    bold: true,
                    color: 'white',
                    fillColor: '#293754',
                    font: 'Lexend',
                }
            },
            defaultStyle: {
                fontSize: 12,
                font: 'Lexend',
            }
        };




        return docDefinition;
    };


    const generatePdfContent = async (selectedPurchase, matchingDispatchProcess) => {
        // BulkData.map((data, index) => (
        //     <Box key={data._id}>
        //         {data.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"))?.map((process, index) 
        let xx = matchingDispatchProcess?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"));

        await getLexendFonts();

        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
            Lexend: {
                normal: 'Lexend-Regular.ttf',
                bold: 'Lexend-Bold.ttf',
            }
        };

        const logoSrc = theme.palette.mode === "dark" ? '../../assets/images/logo/logo.svg' : '../../assets/images/logo/logo.svg';
        const logoBase64 = await getBase64Image(logoSrc);
        const stampImg = await getBase64Image("../../assets/images/stamp/stamp.svg")
        const allPagesContent = [];
        matchingDispatchProcess?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"))?.forEach((processItem, index) => {


            if (index > 0) {
                allPagesContent.push({ text: '', pageBreak: 'before' });
            }

            allPagesContent.push(
                {
                    columns: [
                        {
                            image: logoBase64,
                            width: 100,
                            margin: [0, 0, 0, 0]
                        },
                        {
                            text: processItem?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN',
                            style: 'header',
                            alignment: 'right',
                            margin: [0, 0, 0, 2],
                            decoration: 'underline',
                            decorationColor: '#FB9822',
                            fontSize: 16,
                            characterSpacing: 2
                        },

                    ],
                },

                {
                    table: {
                        widths: ['50%'],
                        body: [
                            []
                        ]
                    },
                    margin: [0, 20, 0, 0]
                },
                {

                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'CUSTOMER DETAILS',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        },

                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            table: {
                                widths: ['32%', '2%', '66%'],
                                body: [
                                    [
                                        { text: 'Dispatch No', bold: true, fontSize: 9, border: [false, false, false, false] },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: processItem?.generatedNumber || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Date', bold: true, fontSize: 9, border: [false, false, false, false] },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: format(new Date(processItem?.DispatchDate), 'dd-MM-yyyy') || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.body.length) ? 0 : 0;
                                },
                                vLineWidth: function (i, node) {
                                    return 0;
                                },
                            }
                        }
                    ],
                    margin: [0, 20, 0, 20]
                },
                {
                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['42%', '2%', '56%'], // Changed widths
                                body: [
                                    [
                                        { text: 'Customer Name', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedPurchase?.ConsumerName + ' (' + selectedPurchase?.fillNo + ')' || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Customer Address', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedPurchase?.Address || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Customer Mobile No', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedPurchase?.PhoneNumber || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.body.length) ? 0 : 0;
                                },
                                vLineWidth: function (i, node) {
                                    return 0;
                                },
                            }
                        }
                    ]
                },
                {
                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'TVARIT ADDRESS',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        },
                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'SHIP FROM',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        }
                    ],
                    margin: [0, 20, 0, 20]
                },

                {
                    columns: [
                        {
                            width: '48%',
                            stack: [
                                {
                                    table: {
                                        widths: ['42%', '2%', '56%'],
                                        body: [
                                            [
                                                { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.companyName, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Address', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.address, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'GST No', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.gst, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Contact No', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.contactNumber, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Email', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.email, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Website', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.website, border: [false, false, false, false], fontSize: 9 }
                                            ]
                                        ]
                                    },
                                    layout: {
                                        defaultBorder: false,
                                        paddingLeft: function (i) { return 4; },
                                        paddingRight: function (i) { return 4; },
                                        paddingTop: function (i) { return 4; },
                                        paddingBottom: function (i) { return 4; }
                                    }
                                }
                            ]
                        },
                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            stack: [
                                {
                                    table: {
                                        widths: ['42%', '2%', '56%'],
                                        body: [
                                            [
                                                { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                {
                                                    text: (() => {
                                                        if (!matchingDispatchProcess?.ProcessData?.[index]) return 'N/A';
                                                        const warehouseName = matchingDispatchProcess.ProcessData[index]?.DebitCreditWarehouseData?.wareHouseName || 'N/A';
                                                        return warehouseName || 'N/A';
                                                    })(), border: [false, false, false, false], fontSize: 9, alignment: 'start'
                                                }

                                            ]
                                        ]
                                    },
                                    layout: {
                                        defaultBorder: false,
                                        paddingLeft: function (i) { return 4; },
                                        paddingRight: function (i) { return 4; },
                                        paddingTop: function (i) { return 4; },
                                        paddingBottom: function (i) { return 4; }
                                    }
                                }
                            ]
                        }
                    ]
                },

                {
                    table: {
                        headerRows: 1,
                        widths: ['auto', '*', '*', 'auto'],
                        body: [
                            [
                                { text: 'SR. NO.', style: 'tableHeader', border: [true, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'PRODUCT NAME', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'QTY.', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            ],
                            ...generateProductRows(processItem)
                        ]
                    },
                    margin: [0, 10, 0, 0] // Reduced table margin
                },
                {
                    width: '*',
                    stack: [
                        {
                            image: stampImg,
                            width: 150,
                            alignment: 'right'
                        },
                        {
                            text: 'Company Stamp & Sign',
                            alignment: 'right',
                            bold: true,
                            margin: [0, 5, 0, 0]
                        }
                    ],
                    margin: [0, 20, 0, 0] // Reduced stamp margin
                }
            );
        });




        // Check for bulk data
        const processbulkIds = AlldispatchProcess.find(process => process._id === dispatchProcessId);
        const bulkIds = processbulkIds?.ProcessData.map(p => p.bulkId).filter(Boolean);
        const bulkfiltered = AlldispatchProcess.filter(process =>
            process.ProcessData.some(data => bulkIds?.includes(data.bulkId))
        );


        const docDefinition = {
            content: allPagesContent,
            styles: {
                header: {
                    fontSize: 25,
                    bold: true,
                    color: '#1F2F58',
                    font: 'Lexend',
                },
                subheader: {
                    fontSize: 20,
                    bold: true,
                    margin: [0, 10, 0, 5],
                    font: 'Lexend',
                },
                tableHeader: {
                    bold: true,
                    color: 'white',
                    fillColor: '#293754',
                    font: 'Lexend',
                }
            },
            defaultStyle: {
                fontSize: 12,
                font: 'Lexend',
            }
        };




        return docDefinition;
    };

    const processAllDispatchDetails = (data) => {



        return data.map(dispatchData => {
            const generatedNumber = dispatchData.generatedNumber;
            const dispatchDetails = dispatchData.DispatchDetails;
            const debitCreditWarehouseData = dispatchData.DebitCreditWarehouseData;

            const processedDispatchDetails = [];
            const seenKitNos = new Set(); // Keep track of seen KitNo values

            dispatchDetails.forEach(detail => {
                if (detail.DispatchKitId && seenKitNos.has(detail.KitNo)) {
                    return; // Skip if KitNo already seen
                }

                if (detail.DispatchKitId) {
                    seenKitNos.add(detail.KitNo);
                }

                const processedDetail = {
                    ...detail,
                    generatedNumber,
                    DebitCreditWarehouseData: debitCreditWarehouseData
                };

                if (detail.DispatchKitData) {
                    processedDetail.KitData = detail.DispatchKitData;
                }

                processedDispatchDetails.push(processedDetail);

            });

            return {
                generatedNumber,
                bulkId: dispatchData.bulkId,
                PurposeofDispatch: dispatchData.PurposeofDispatch,
                DispatchSuggestionId: dispatchData.DispatchSuggestionId,
                DispatchDate: dispatchData.DispatchDate,
                DebitCreditWarehouseName: dispatchData.DebitCreditWarehouseName,
                DebitCreditWarehouseData: dispatchData.DebitCreditWarehouseData,
                DispatchModelTransport: dispatchData.DispatchModelTransport,
                DispatchRemarks: dispatchData.DispatchRemarks,
                createProcessDate: dispatchData.createProcessDate,
                DispatchDetails: processedDispatchDetails
            };
        });
    }

    const downloadPDF = async () => {

        await getLexendFonts();

        if (BulkData.length > 0) {
            const allContent = [];

            for (const [index, process] of BulkData.entries()) {
                const marketData = Market.find(m => m._id === process.marketId);
                const fData = await processAllDispatchDetails(process.ProcessData);
                const matchingDispatchProcess = AlldispatchProcess.find(
                    process => process.marketId === marketData?._id
                );




                const docDefinition = await generatePdfContent(marketData, { ...matchingDispatchProcess, ProcessData: fData });




                allContent.push(...docDefinition.content);



                // if (process !== BulkData[BulkData.length - 1]) {
                //     allContent.push({ text: '', pageBreak: 'before' });
                //     const docDefinitionB = await generatePdfContentBulk(marketData, { ...matchingDispatchProcess, ProcessData: fData });

                //     allContent.push(...docDefinitionB.content);
                // }

                if (index !== BulkData.length - 1) {
                    allContent.push({ text: '', pageBreak: 'before' });

                }

                if (index === BulkData.length - 1) {
                    const docDefinitionB = await generatePdfContentBulk(marketData, { ...matchingDispatchProcess, ProcessData: fData });

                    allContent.push(...docDefinitionB.content);
                }
            }



            await getLexendFonts();

            const finalDocDefinition = {
                content: allContent,
                defaultStyle: {
                    font: 'Lexend',
                },
                styles: {
                    header: {
                        fontSize: 25,
                        bold: true,
                        color: '#1F2F58',
                        font: 'Lexend', // Ensure Lexend is used
                    },
                    subheader: {
                        fontSize: 20,
                        bold: true,
                        margin: [0, 10, 0, 5],
                        font: 'Lexend', // Ensure Lexend is used
                    },
                    tableHeader: {
                        bold: true,
                        color: 'white',
                        fillColor: '#293754',
                        font: 'Lexend', // Ensure Lexend is used
                    },
                },
                defaultStyle: {
                    fontSize: 12,
                    font: 'Lexend', // Set Lexend as the default font
                },
            };
            pdfMake.createPdf(finalDocDefinition).download('multiple_dispatch_challans.pdf');
        } else {
            const matchingDispatchProcess = AlldispatchProcess.find(
                process => process.marketId === selectedPurchase?._id
            );



            const fData = await processAllDispatchDetails(BulkData);


            const docDefinition = await generatePdfContent(selectedPurchase, { ...matchingDispatchProcess, ProcessData: fData });
            pdfMake.createPdf(docDefinition).download('dispatch_challan.pdf');
        }
    };




    return (
        <Box m="2px">
            {id ? (
                <Header
                    title="UPDATE BULK DISPATCH PROCESS"
                    subtitle="Update Your Bulk Dispatch Process Here"
                />
            ) : (
                <Header
                    title="BULK DISPATCH PROCESS"
                    subtitle="Manage Your Bulk Dispatch Process Here"
                />
            )}

            <form onSubmit={handleSubmit} enctype="multipart/form-data">
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                        {FileNos.map((label, index) => (
                            <Step key={label}>
                                <StepLabel StepIconComponent={(props) => (
                                    <ColorlibStepIcon
                                        {...props}
                                        theme={theme}
                                        onClick={() => handleStep(index)}
                                        error={touchedSteps[index] && stepsWithErrors[index]}
                                    >
                                        <span style={{ fontSize: '14px', color: theme.palette.text.primary }}>{label}</span>
                                    </ColorlibStepIcon>
                                )} />
                            </Step>
                        ))}
                    </Stepper>
                    <Box>
                        {mid.map((mid, midIndex) => {
                            // const currentProcesses = values?.filter(p => p.marketId === mid);
                            return (
                                <>
                                    {activeStep === midIndex && values[midIndex]?.ProcessData.map((process, i) => {
                                        const currentReturnCount = values?.[midIndex]?.ProcessData?.slice(0, i + 1).filter(p => p?.PurposeofDispatch === "Return Material")?.length;
                                        const currentDispatchCount = values?.[midIndex]?.ProcessData?.slice(0, i + 1).filter(p => p?.PurposeofDispatch === "Customer Material")?.length;
                                        const MarketData = Market?.find(m => m._id === mid) || ''

                                        const cellStyle = {
                                            border: `1px solid ${theme.palette.text.primary}`,
                                            fontSize: '14px',
                                            textAlign: 'center',
                                            padding: '10px',
                                        };

                                        const masterGrouped = {};

                                        values.forEach((value) => {
                                            const FileNo = Market?.find(m => m._id === value.marketId)?.fillNo || '';
                                            const ConsumerName = Market?.find(m => m._id === value.marketId)?.ConsumerName || '';

                                            value.ProcessData
                                                ?.filter(v => !v?.generatedNumber)
                                                ?.forEach((process) => {
                                                    process.DispatchDetails?.forEach((detail) => {
                                                        const productName = products.find(p => p._id === detail.DispatchProductName)?.productName;
                                                        const kitName = kitproductdata?.find(k => k._id === detail.DispatchProductName)?.KitName;
                                                        const nameKey = productName || kitName || 'Unknown Product';

                                                        if (!masterGrouped[nameKey]) {
                                                            masterGrouped[nameKey] = {
                                                                totalQty: 0,
                                                                detail, // Keep the first matched detail
                                                                category: categories.find(c => c._id === detail.DispatchCatogory)?.categoryName || 'Not Available',
                                                                subcategory: subcategories.find(s => s._id === detail.DispatchSubCatogory)?.subCategoryName || 'Not Available',
                                                                nameKey,
                                                                purposes: new Set(), // Track all purposes
                                                                fileNos: new Set(), // Track all file numbers
                                                                consumerNames: new Set() // Track all consumer names
                                                            };
                                                        }

                                                        masterGrouped[nameKey].totalQty += Number(detail.DispatchQty || 0);
                                                        masterGrouped[nameKey].purposes.add(process.PurposeofDispatch);
                                                        masterGrouped[nameKey].fileNos.add(FileNo);
                                                        masterGrouped[nameKey].consumerNames.add(ConsumerName);
                                                    });
                                                });
                                        });
                                        return (
                                            <>
                                                {

                                                    <>
                                                        {
                                                            i === 0 ?
                                                                <Box sx={{ position: 'sticky', top: -20, background: theme.palette.background.default, zIndex: 10, padding: '20px', overflowX: 'auto' }}>
                                                                    <div style={{ display: 'flex', color: theme.palette.text.primary, whiteSpace: 'nowrap' }}>
                                                                        <ul style={{ listStyle: 'none', padding: 0 }}>
                                                                            <li>File No</li>
                                                                            <li>Customer Name</li>
                                                                            <li>System Size </li>
                                                                            <li>Address </li>
                                                                            <li>City </li>
                                                                            <li>Dealer Name </li>
                                                                        </ul>
                                                                        <ul style={{ listStyle: 'none' }}>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.fillNo}</li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.ConsumerName}</li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.SystemSizeKw}</li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.Address}</li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.City_Village}</li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.userData?.[0].name}</li>
                                                                        </ul>
                                                                        <ul style={{ listStyle: 'none' }}>
                                                                            <li>Customer Pending Payment </li>
                                                                            <li>Marketing Warehouse Name</li>
                                                                            <li>Date of Dispatch</li>
                                                                            <li>Solar PV</li>
                                                                            <li>Solar Inverter </li>
                                                                        </ul>
                                                                        <ul style={{ listStyle: 'none' }}>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                {(() => {
                                                                                    if (!MarketData?.AccountData || MarketData?.AccountData?.length === 0) {
                                                                                        return 'No Account Data Available';
                                                                                    }

                                                                                    const accountDetails = MarketData?.AccountData[0]?.AccountDetails || [];
                                                                                    const totalAccountAmount = accountDetails.reduce(
                                                                                        (sum, account) => sum + parseFloat(account?.AccountAmount || 0),
                                                                                        0
                                                                                    );

                                                                                    const remainingAmount = parseFloat(MarketData?.TotalAmount || 0) - totalAccountAmount;

                                                                                    return remainingAmount > 0
                                                                                        ? `${remainingAmount}`
                                                                                        : 'Fully Paid';
                                                                                })()}
                                                                            </li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.wareHouseData?.length > 0 ? MarketData.wareHouseData[0].wareHouseName : "No warehouse data available"}</li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                {AlldispatchProcess?.find(v => v.marketId === MarketData?._id)?.ProcessData
                                                                                    ?.map(data => format(new Date(data.DispatchDate), 'dd-MM-yyyy')).join(', ') || 'N/A'}
                                                                            </li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.productData?.[0].productName} ({MarketData?.SolarModuleNos})</li>
                                                                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{MarketData?.inverterData?.[0].productName}</li>
                                                                        </ul>
                                                                    </div>
                                                                </Box> : null
                                                        }

                                                        <Box
                                                            key={i}
                                                            display="grid"
                                                            gap="30px"
                                                            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                                            sx={{
                                                                "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                                                mb: 2
                                                            }}>
                                                            <div style={{
                                                                gridColumn: "span 1",
                                                                color: theme.palette.text.primary,
                                                                fontSize: '18px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                                {process?.PurposeofDispatch === "Return Material"
                                                                    ? (currentReturnCount > 0 ? `Return ${currentReturnCount} - ${MarketData?.fillNo}` : '')
                                                                    : (currentDispatchCount > 0 ? `Dispatch ${currentDispatchCount} - ${MarketData?.fillNo}` : '')}
                                                            </div>
                                                            <TextField
                                                                disabled={process?.generatedNumber}
                                                                margin="dense"
                                                                label="Date : "
                                                                variant="filled"
                                                                type="date"
                                                                fullWidth
                                                                value={values[midIndex]?.ProcessData[i]?.DispatchDate}
                                                                name={`values[${midIndex}].ProcessData[${i}].DispatchDate`}
                                                                onChange={(e) => handleDispatchDetailChange(midIndex, i, 'DispatchDate', e.target.value)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                    style: {
                                                                        color: theme.palette.text.primary
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                                error={touched.ProcessData?.[midIndex]?.[i]?.DispatchDate && Boolean(errors.ProcessData?.[midIndex]?.[i]?.DispatchDate)}
                                                                helperText={touched.ProcessData?.[midIndex]?.[i]?.DispatchDate && errors.ProcessData?.[midIndex]?.[i]?.DispatchDate}
                                                            />
                                                            <TextField
                                                                disabled={process?.generatedNumber}
                                                                margin="dense"
                                                                label="Purpose of Dispatch :"
                                                                variant="filled"
                                                                select
                                                                name={`values[${midIndex}].ProcessData[${i}].PurposeofDispatch`}
                                                                value={values[midIndex]?.ProcessData[i]?.PurposeofDispatch || "Customer Material"}
                                                                onBlur={handleBlur}
                                                                fullWidth
                                                                onChange={(e) => handleDispatchDetailChange(midIndex, i, 'PurposeofDispatch', e.target.value)}
                                                                error={touched.ProcessData?.[i]?.PurposeofDispatch && Boolean(errors.ProcessData?.[i]?.PurposeofDispatch)}
                                                                helperText={touched.ProcessData?.[i]?.PurposeofDispatch && errors.ProcessData?.[i]?.PurposeofDispatch}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: theme.palette.text.primary
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem value="Customer Material">Customer Material</MenuItem>
                                                                <MenuItem value="Return Material">Return Material</MenuItem>
                                                            </TextField>
                                                            {process?.PurposeofDispatch === "Customer Material" && (
                                                                <TextField
                                                                    disabled={process?.generatedNumber}
                                                                    margin="dense"
                                                                    label="Dispatch Suggestion :"
                                                                    variant="filled"
                                                                    select
                                                                    fullWidth
                                                                    name={`values[${midIndex}].ProcessData[${i}].DispatchSuggestionId`}
                                                                    onChange={(e) => handleDispatchSuggestion(e, i, midIndex, 'DispatchSuggestionId', MarketData)}
                                                                    value={values[midIndex]?.ProcessData[i]?.DispatchSuggestionId || ''}
                                                                    InputLabelProps={{
                                                                        style: {
                                                                            color: theme.palette.text.primary
                                                                        }
                                                                    }}
                                                                >
                                                                    {suggestiondata?.map((suggestion) => (
                                                                        <MenuItem key={suggestion._id} value={suggestion._id}>
                                                                            {suggestion.ProjectName}
                                                                        </MenuItem>
                                                                    ))}
                                                                </TextField>
                                                            )}
                                                        </Box>
                                                        <Box sx={{ overflowX: "auto", width: "100%" }}>
                                                            <TableContainer>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell sx={{ width: "70px", fontSize: "14px" }}> Sr No</TableCell>
                                                                            <TableCell sx={{ fontSize: "14px" }}>Category</TableCell>
                                                                            <TableCell sx={{ fontSize: "14px" }}>Sub Category</TableCell>
                                                                            <TableCell sx={{ fontSize: "14px" }}>Product Name</TableCell>
                                                                            <TableCell sx={{ fontSize: "14px" }}>Description</TableCell>
                                                                            <TableCell sx={{ fontSize: "14px" }}>Unit of Measurement</TableCell>
                                                                            <TableCell sx={{ fontSize: "14px" }}>Quantity</TableCell>
                                                                            <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>

                                                                        {
                                                                            // values[midIndex]?.ProcessData[i]?.DispatchDetails?.map((detail, index) => {
                                                                            values[midIndex].ProcessData[i].DispatchDetails?.reduce((acc, detail) => {




                                                                                const kitNo = detail.KitNo;
                                                                                // Check if this KitNo already exists in the accumulator
                                                                                if (!acc.find(item => item.KitNo === kitNo && kitNo > 0)) {
                                                                                    acc.push(detail); // Only add unique KitNo entries
                                                                                }
                                                                                return acc;
                                                                            }, []).map((detail, index) => {
                                                                                // Now map through the unique entries
                                                                                let d = AlldispatchProcess?.ProcessData?.some(process =>
                                                                                    process.DispatchDetails.includes(detail)
                                                                                );

                                                                                let dd = AlldispatchProcess?.find(v => v.marketId === MarketData?._id)
                                                                                    ?.ProcessData?.some(process =>
                                                                                        process.DispatchDetails.some(d =>
                                                                                            JSON.stringify({ ...d, DispatchKitId: d.DispatchKitId ?? "" }) ===
                                                                                            JSON.stringify({ ...detail, DispatchKitId: detail.DispatchKitId ?? "" })
                                                                                        )
                                                                                    );





                                                                                const isKit = detail.DispatchKitId; // Check if this is a kit
                                                                                const kitData = isKit ? kitproductdata.find(kit => kit._id === detail.DispatchKitId) : null;

                                                                                let kname = isKit ? categories.find(cat => cat._id === kitCategoryId)?.categoryName
                                                                                    : null


                                                                                return (
                                                                                    <MemoizedTableRow
                                                                                        key={detail.id || index}
                                                                                        detail={detail}
                                                                                        i={i}
                                                                                        d={dd}
                                                                                        index={index}
                                                                                        isKit={isKit}
                                                                                        kitData={kitData}
                                                                                        midIndex={midIndex}
                                                                                        MarketData={MarketData}
                                                                                    />
                                                                                )
                                                                            })}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        </Box>
                                                    </>
                                                }
                                                <Box display="flex" justifyContent="flex-end" m={1}>
                                                    <Button
                                                        disabled={i < AlldispatchProcess?.find(v => v.marketId === MarketData?._id)?.ProcessData?.length ? true : false}
                                                        variant="contained"
                                                        color="primary"
                                                        startIcon={<AddIcon />}
                                                        onClick={() => { handleAddDispatchDetail(midIndex, i) }}
                                                    >
                                                        Add Dispatch Detail
                                                    </Button>
                                                </Box>
                                            </>
                                        )
                                    })
                                    }
                                    {activeStep === midIndex && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            onClick={() => { handleAddProcess(mid) }}
                                        >
                                            Add Process
                                        </Button>
                                    )}
                                </>
                            )
                        })}

                        {activeStep === FileNos.length - 1 && (
                            <Box sx={{ mt: 2 }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Purpose</TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Category</TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Sub Category</TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Product Name</TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Description</TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Unit of Measurement</TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Quantity</TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>
                                                    Available Quantity
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(() => {
                                                // Create a master grouping across all values
                                                const masterGrouped = {};

                                                values?.forEach((value) => {
                                                    console.log("Current value:", value);
                                                    console.log("Market ID:", value.marketId);
                                                    console.log("ProcessData exists:", !!value.ProcessData);

                                                    const FileNo = Market?.find(m => m._id === value.marketId)?.fillNo || '';
                                                    const ConsumerName = Market?.find(m => m._id === value.marketId)?.ConsumerName || '';

                                                    value.ProcessData
                                                        ?.filter(v => !v?.generatedNumber)
                                                        ?.forEach((process) => {
                                                            process.DispatchDetails.forEach((detail) => {
                                                                const productName = products.find(p => p._id === detail.DispatchProductName)?.productName;
                                                                const kitName = kitproductdata?.find(k => k._id === detail.DispatchProductName)?.KitName;
                                                                const nameKey = productName || kitName || 'Unknown Product';

                                                                if (!masterGrouped[nameKey]) {
                                                                    masterGrouped[nameKey] = {
                                                                        totalQty: 0,
                                                                        detail,
                                                                        category: categories.find(c => c._id === detail.DispatchCatogory)?.categoryName || 'Not Available',
                                                                        subcategory: subcategories.find(s => s._id === detail.DispatchSubCatogory)?.subCategoryName || 'Not Available',
                                                                        nameKey,
                                                                        purposes: new Set(),
                                                                        fileNos: new Set(),
                                                                        consumerNames: new Set()
                                                                    };
                                                                }

                                                                masterGrouped[nameKey].totalQty += Number(detail.DispatchQty || 0);
                                                                masterGrouped[nameKey].purposes.add(process.PurposeofDispatch);
                                                                masterGrouped[nameKey].fileNos.add(FileNo);
                                                                masterGrouped[nameKey].consumerNames.add(ConsumerName);
                                                            });
                                                        });
                                                });

                                                const requiredQtyMap = new Map();

                                                Object.values(masterGrouped).forEach(item => {
                                                    if (item.detail.DispatchKitId) {
                                                        const kit = kitproductdata.find(k => k._id === item.detail.DispatchKitId);
                                                        if (kit) {
                                                            for (let kitItem of kit.KitDetails) {
                                                                const name = kitItem.KitProductName;
                                                                const qty = parseInt(kitItem.KitQty);

                                                                if (requiredQtyMap.has(name)) {
                                                                    requiredQtyMap.set(name, requiredQtyMap.get(name) + qty);
                                                                } else {
                                                                    requiredQtyMap.set(name, qty * item.totalQty);
                                                                }
                                                            }
                                                        }
                                                    } else {
                                                        const name = item.detail.DispatchProductName;
                                                        const qty = item.totalQty;

                                                        if (requiredQtyMap.has(name)) {
                                                            requiredQtyMap.set(name, requiredQtyMap.get(name) + qty);
                                                        } else {
                                                            requiredQtyMap.set(name, qty);
                                                        }
                                                    }
                                                });

                                                let shouldHighlight = false;

                                                requiredQtyMap.forEach((requiredQty, productName) => {
                                                    const available = getAvailableQty(selectedMarketData[0]?.WarehouseId, productName);
                                                    if (requiredQty > available) {
                                                        shouldHighlight = true;
                                                    }
                                                });


                                                // const insufficientProducts = new Set();

                                                // requiredQtyMap.forEach((requiredQty, productId) => {
                                                //     const available = getAvailableQty(selectedMarketData[0]?.WarehouseId, productId);
                                                //     if (requiredQty > available) {
                                                //         insufficientProducts.add(productId);
                                                //     }
                                                // });



                                                console.log("masterGrouped", isSubmitted , disableSubmit , insufficientProducts.size > 0, insufficientProducts)

                                                // Convert the grouped data to an array and render
                                                return Object.values(masterGrouped)
                                                    .sort((a, b) => {
                                                        const catA = a.category?.toLowerCase() || '';
                                                        const catB = b.category?.toLowerCase() || '';
                                                        return catB.localeCompare(catA); // Descending order
                                                    })
                                                    .map((item, index) => {
                                                        const productId = item.detail.DispatchProductName || item.detail.DispatchKitId;
                                                        const availableQty = getAvailableQty(selectedMarketData[0]?.WarehouseId, productId);

                                                        const isCustomerMaterial = item.purposes?.has?.("Customer Material");

                                                        console.log("Processing item:", item.nameKey, "Purposes:", item.purposes, "DispatchKitId:", item.detail.DispatchKitId);

                                                        const isInsufficient = isCustomerMaterial ? (() => {
                                                            console.log("Inside isCustomerMaterial check for:", item.nameKey);
                                                            console.log("item.detail.DispatchKitId within isCustomerMaterial block:", item.detail.DispatchKitId); // This is your current log

                                                            if (item.detail.DispatchKitId) {
                                                                const kit = kitproductdata.find(k => k._id === item.detail.DispatchKitId);
                                                                console.log("Found kit:", kit); // Log the found kit
                                                                if (kit) {
                                                                    return kit.KitDetails.some(kitItem => {
                                                                        const required = requiredQtyMap.get(kitItem.KitProductName) || 0;
                                                                        const available = getAvailableQty(selectedMarketData[0]?.WarehouseId, kitItem.KitProductName);
                                                                        console.log("Kit Item:", kitItem.KitProductName, "Required:", required, "Available:", available);
                                                                        return required > available;
                                                                    });
                                                                }
                                                                console.log(kit, "kitkitkitkitkit"); // This log is also here
                                                                return false;
                                                            } else {
                                                                const required = requiredQtyMap.get(item.detail.DispatchProductName) || 0;
                                                                const available = getAvailableQty(selectedMarketData[0]?.WarehouseId, item.detail.DispatchProductName);
                                                                console.log("Individual Product:", item.nameKey, "Required:", required, "Available:", available);
                                                                return required > available;
                                                            }
                                                        })() : false;

                                                        if (insufficientProducts.has(productId)) {
                                                            console.log("gggggggggggggg", productId, insufficientProducts);
                                                        }

                                                        const cellStyle = {
                                                            border: `1px solid ${theme.palette.text.primary}`,
                                                            fontSize: '14px',
                                                            textAlign: 'center',
                                                            padding: '10px',
                                                            color: insufficientProducts.has(productId) ? 'red' : 'black'
                                                        };

                                                        return (
                                                            <TableRow
                                                                key={`product-${index}`}
                                                                sx={{
                                                                    cursor: shouldHighlight ? 'pointer' : 'default',
                                                                    backgroundColor: highlightedRowIndex === index && shouldHighlight
                                                                        ? theme.palette.error.light
                                                                        : 'transparent',
                                                                }}
                                                            >
                                                                <TableCell sx={cellStyle}>
                                                                    {Array.from(item.purposes).join(', ')}
                                                                </TableCell>
                                                                <TableCell sx={cellStyle}>
                                                                    {item.category}
                                                                </TableCell>
                                                                <TableCell sx={cellStyle}>
                                                                    {item.subcategory}
                                                                </TableCell>
                                                                <TableCell sx={cellStyle}>
                                                                    {item.nameKey}
                                                                </TableCell>
                                                                <TableCell sx={cellStyle}>
                                                                    {item.detail.DispatchDiscription || 'Not Available'}
                                                                </TableCell>
                                                                <TableCell sx={cellStyle}>
                                                                    {item.detail.DispatchUnit || 'Not Available'}
                                                                </TableCell>
                                                                <TableCell sx={cellStyle}>
                                                                    {item.totalQty}
                                                                </TableCell>
                                                                <TableCell sx={cellStyle}>
                                                                    {availableQty || '-'}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    });


                                            })()}
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, borderLeft: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>

                                                <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Total Quantity</TableCell>

                                                <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, borderRight: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>
                                                    {values.reduce((total, value) => {
                                                        return total + value.ProcessData.filter(v => !v?.generatedNumber)?.filter(v => !v?.generatedNumber).reduce((processTotal, process) => {
                                                            return processTotal + process.DispatchDetails.reduce((detailTotal, detail) => {
                                                                return detailTotal + Number(detail.DispatchQty);
                                                            }, 0);
                                                        }, 0);
                                                    }, 0)}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        )}
                    </Box>

                    <Dialog
                        open={openConfirmDialog}
                        onClose={() => setOpenConfirmDialog(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Are you sure you want to delete this item?"}
                        </DialogTitle>
                        <DialogActions>
                            <Button onClick={() => setOpenConfirmDialog(false)} sx={{ color: theme.palette.text.primary }}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => handleDeleteConfirm(selectedDetail)}
                                color="error"
                                autoFocus
                            >
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={open} onClose={handleClose}>
                        <DialogTitle>{id ? 'Edit Dispatch Process' : 'Add Dispatch Process'}</DialogTitle>
                        <DialogContent>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                    marginBottom: '20px',
                                }}
                            >
                                <TextField
                                    margin="dense"
                                    label={dialogValues.PurposeofDispatch === "Return Material" ? "Credit Warehouse Name :" : "Debit Warehouse Name :"}
                                    variant="filled"
                                    select
                                    fullWidth
                                    value={state?.selectedMarketData[0].wareHouseData[0]?._id || ''}
                                    // value={dialogValues.DebitCreditWarehouseName || ''}
                                    onChange={(e) => setDialogValues({ ...dialogValues, DebitCreditWarehouseName: e.target.value })}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                    name="DebitCreditWarehouseName"
                                    onBlur={handleBlur}
                                    error={touched.DebitCreditWarehouseName && Boolean(errors.DebitCreditWarehouseName)}
                                    helperText={touched.DebitCreditWarehouseName && errors.DebitCreditWarehouseName}
                                    sx={{ display: 'none' }}
                                >
                                    {warehousedata?.map((warehouse) => (
                                        <MenuItem key={warehouse._id} value={warehouse._id}>
                                            {warehouse.wareHouseName}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <TextField
                                    margin="dense"
                                    label="Mode Of Transport : "
                                    variant="filled"
                                    fullWidth
                                    name="DispatchModelTransport"
                                    onBlur={handleBlur}
                                    value={dialogValues.DispatchModelTransport || ''}
                                    onChange={(e) => setDialogValues({ ...dialogValues, DispatchModelTransport: e.target.value })}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                    error={touched.DispatchModelTransport && Boolean(errors.DispatchModelTransport)}
                                    helperText={touched.DispatchModelTransport && errors.DispatchModelTransport}

                                />
                                <TextField
                                    margin="dense"
                                    label="Remarks : "
                                    variant="filled"
                                    fullWidth
                                    name="DispatchRemarks"
                                    error={touched.DispatchRemarks && Boolean(errors.DispatchRemarks)}
                                    helperText={touched.DispatchRemarks && errors.DispatchRemarks}
                                    onBlur={handleBlur}
                                    value={dialogValues.DispatchRemarks || ''}
                                    onChange={(e) => setDialogValues({ ...dialogValues, DispatchRemarks: e.target.value })}
                                    InputLabelProps={{
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} style={{ color: theme.palette.text.primary }}>Cancel</Button>
                            <Button
                                onClick={handleSubmit}
                                disabled={isSubmitted}
                            >
                                {id ? 'Update' : 'Submit'}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleNext}
                                disabled={isLastStep ? isSubmitted || disableSubmit || insufficientProducts.size > 0 : false}
                            >
                                {isLastStep ? (id ? 'Update1' : 'Save') : 'Next'}
                            </Button>



                            <IconButton aria-label="print" style={{ color: "white", backgroundColor: "#141b2d" }} sx={{ ml: 2, bgcolor: '#141b2d', padding: "10px", boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)" }}
                                onClick={() => handlePrint(mid)}
                            >
                                <PrintIcon />
                            </IconButton>
                        </Stack>
                    </FormControl>


                    <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
                        <DialogContent>
                            {(() => {
                                const bulkIds = AlldispatchProcess.map(bulk => bulk?.ProcessData?.map(process => process.bulkId).filter(Boolean)).flat();
                                return (
                                    <>
                                        {
                                            BulkData.length > 0 ? (
                                                BulkData.map((data, index) => (
                                                    <Box key={data._id}>
                                                        {data.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"))?.map((process, index) => {

                                                            const displayedKits = new Set();

                                                            return (
                                                                <Box key={index} sx={{ padding: 2 }} ref={printRef}>
                                                                    <Grid container justifyContent="space-between" alignItems="center" sx={{ marginBottom: 4 }}>
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Box
                                                                                component="img"
                                                                                className='pdf-logo'
                                                                                src={(theme.palette.mode === "dark" ? '../../assets/images/logo/dark-logo.png' : '../../assets/images/logo/logo.svg')}
                                                                                alt="Tvarit Energy LLP Logo"
                                                                                sx={{ width: { xs: '100%', sm: '150px' }, maxWidth: '150px' }}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Box sx={{ textAlign: 'right', marginBottom: 2 }}>
                                                                                <Typography
                                                                                    variant="h5"
                                                                                    className="purchase-order-title"
                                                                                    sx={{
                                                                                        fontWeight: 'bold',
                                                                                        fontSize: '25px',
                                                                                        letterSpacing: '5px',
                                                                                        color: theme.palette.mode === "dark" ? 'white' : '#1F2F58',
                                                                                        position: 'relative',
                                                                                        display: 'inline-block',
                                                                                        borderBottom: '2px solid #FB9822',
                                                                                        paddingBottom: '4px'
                                                                                    }}
                                                                                >
                                                                                    <Typography variant="h5" sx={{ fontSize: window.innerWidth <= 425 ? '22px' : '25px' }}>
                                                                                        {data?.ProcessData?.[index]?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN'}
                                                                                    </Typography>
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}>
                                                                        <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}>
                                                                            <Grid item xs={12} sm={6}>
                                                                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>CUSTOMER DETAILS</Typography>
                                                                                </Box>
                                                                                <Grid container direction="column" spacing={1} sx={{ marginTop: '10px' }}>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Name</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography>{data?.marketData?.ConsumerName + ' (' + data?.marketData?.fillNo + ')' || 'N/A'}</Typography></Grid>
                                                                                    </Grid>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Address</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography>{data?.marketData?.Address || 'N/A' || 'N/A'}</Typography></Grid>
                                                                                    </Grid>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Mobile No</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography>{data?.marketData?.PhoneNumber || 'N/A'}</Typography></Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>

                                                                            <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
                                                                                <Grid item container>
                                                                                    <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                                                                    <Grid item xs={8}>
                                                                                        <Typography sx={{ fontWeight: '600' }}>
                                                                                            {format(new Date(process?.DispatchDate), 'dd-MM-yyyy')}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>

                                                                                <Grid item container>
                                                                                    <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Dispatch Number &nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                                                                    <Grid item xs={8}>
                                                                                        <Typography sx={{ fontWeight: '600' }}>
                                                                                            {process?.generatedNumber || 'N/A'}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>TWARIT ADDRESS</Typography>
                                                                            </Box>
                                                                            <Box sx={{ marginTop: '10px', wordSpacing: '2px' }}>
                                                                                <Grid container direction="column" spacing={1}>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Company Name</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography sx={{ fontWeight: '700' }}>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography sx={{ fontWeight: '700' }}>{orderDetails.billTo.companyName}</Typography></Grid>
                                                                                    </Grid>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Address</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.address}</Typography></Grid>
                                                                                    </Grid>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>GST No</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.gst}</Typography></Grid>
                                                                                    </Grid>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact No</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.contactNumber}</Typography></Grid>
                                                                                    </Grid>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Email</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.email}</Typography></Grid>
                                                                                    </Grid>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Website</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                                                        <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.website}</Typography></Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Box>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={6}>
                                                                            <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>SHIP FROM</Typography>
                                                                            </Box>
                                                                            <Box sx={{ marginTop: '10px', wordSpacing: '2px' }} >
                                                                                <Grid container direction="column" spacing={1}>
                                                                                    <Grid item container>
                                                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Company Name</Typography></Grid>
                                                                                        <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                                                        <Grid item xs={7}>
                                                                                            <Typography sx={{ fontWeight: '600' }}>
                                                                                                {(() => {
                                                                                                    const ProcessWarehouse = AlldispatchProcess.find(process => process.marketId === data.marketData?._id);
                                                                                                    if (!ProcessWarehouse?.ProcessData?.[index]) return 'N/A';

                                                                                                    const warehouseName = ProcessWarehouse.ProcessData[index]?.DebitCreditWarehouseData?.wareHouseName || 'N/A';

                                                                                                    return warehouseName;
                                                                                                })()}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <TableContainer sx={{ marginTop: 2 }}>
                                                                        <Table>
                                                                            <TableHead sx={{ backgroundColor: '#293754' }}>
                                                                                <TableRow>
                                                                                    <TableCell sx={{ color: 'white' }}>SR. NO.</TableCell>
                                                                                    <TableCell sx={{ color: 'white' }}>Category Name</TableCell>
                                                                                    <TableCell sx={{ color: 'white' }}>SubCategory Name</TableCell>
                                                                                    <TableCell sx={{ color: 'white' }}>PRODUCT NAME</TableCell>
                                                                                    <TableCell sx={{ color: 'white' }}>DESCRIPTION</TableCell>
                                                                                    <TableCell sx={{ color: 'white' }}>HSN CODE</TableCell>
                                                                                    <TableCell sx={{ color: 'white' }}>QTY.</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {(() => {
                                                                                    return process.DispatchDetails
                                                                                        ?.map((item, DataIndex) => {
                                                                                            // const productName = item?.KitNo === 0 ?
                                                                                            //     item.DispatchProductNameData || 'N/A' :
                                                                                            //     kitproductdata?.find((k) => k?._id === item.DispatchKitId)
                                                                                            //     ;

                                                                                            let productName = 'N/A';




                                                                                            if (item?.KitNo === 0) {
                                                                                                productName = item?.DispatchProductNameData?.productName || 'N/A';
                                                                                            } else {
                                                                                                const kitProduct = kitproductdata?.find((k) => k?._id === item.DispatchKitId);
                                                                                                if (kitProduct) {
                                                                                                    if (displayedKits.has(item.DispatchKitId)) {
                                                                                                        return null; // Ignore duplicate kits
                                                                                                    }
                                                                                                    displayedKits.add(item.DispatchKitId);
                                                                                                    productName = kitProduct.productName || kitProduct.KitName || 'N/A';
                                                                                                }
                                                                                            }
                                                                                            const categoryName = item.DispatchCatogoryData || 'N/A';
                                                                                            const subcategoryName = item.DispatchSubCatogoryData || 'N/A';
                                                                                            return (
                                                                                                <TableRow key={DataIndex}>
                                                                                                    <TableCell sx={{ fontWeight: '600' }}>{DataIndex + 1}</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? categoryName?.categoryName : 'KitCategory'}</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? subcategoryName?.subCategoryName : 'KitSubCategory'}</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: '600' }}>{productName || 'N/A'}</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? item.DispatchDiscription : 'N/A'}</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? productName?.HSNcode : 'N/A'}</TableCell>
                                                                                                    <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? item.DispatchQty : '1'}</TableCell>
                                                                                                </TableRow>
                                                                                            );
                                                                                        }) || [];
                                                                                })()}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>

                                                                    <Grid container justifyContent="flex-end" style={{ paddingTop: '150px' }}>
                                                                        <Grid item>
                                                                            <Box
                                                                                component="img"
                                                                                className='stamp-sign'
                                                                                src={'../../assets/images/stamp/stamp-1.svg'}
                                                                                alt="Tvarit Energy LLP stamp"
                                                                                sx={{ width: 150 }}
                                                                            />
                                                                            <Typography variant="body1" sx={{ fontWeight: '600' }}>Company Stamp & Sign</Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>
                                                            )
                                                        })}
                                                    </Box>
                                                ))
                                            ) : (
                                                <Typography variant="h5" textAlign={'center'}>
                                                    No PDF Available
                                                </Typography>
                                            )
                                        }
                                        {(BulkData.length > 0) &&
                                            <Box>


                                                <Grid container justifyContent="space-between" alignItems="center" sx={{ marginBottom: 4 }}>
                                                    <Grid item xs={12} sm={6}>
                                                        <Box
                                                            component="img"
                                                            className='pdf-logo'
                                                            src={(theme.palette.mode === "dark" ? '../../assets/images/logo/dark-logo.png' : '../../assets/images/logo/logo.svg')}
                                                            alt="Tvarit Energy LLP Logo"
                                                            sx={{ width: { xs: '100%', sm: '150px' }, maxWidth: '150px' }}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Typography variant="h2" sx={{ color: theme.palette.text.primary, fontWeight: '700' }}>
                                                    Bulk Dispatch Detail
                                                </Typography>




                                                {
                                                    BulkData.length > 0 && (
                                                        <TableContainer sx={{ marginTop: 2 }}>
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        {/* <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>File No</TableCell>
                                                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Customer Name</TableCell> */}
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Purpose</TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Category</TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Sub Category</TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Product Name</TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Description</TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Unit of Measurement</TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Quantity</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {(() => {
                                                                        const masterGrouped = {};

                                                                        BulkData?.forEach((bulkItem) => {
                                                                            const FileNo = bulkItem.marketData?.fillNo || 'N/A';
                                                                            const ConsumerName = bulkItem.marketData?.ConsumerName || 'N/A';

                                                                            bulkItem?.ProcessData?.filter(p => p.bulkId === localStorage.getItem("bulkId"))?.forEach((process) => {
                                                                                const displayedKits = new Set();

                                                                                process.DispatchDetails.forEach((detail) => {
                                                                                    let nameKey = 'N/A';
                                                                                    let category = 'N/A';
                                                                                    let subcategory = 'N/A';
                                                                                    let description = 'N/A';
                                                                                    let unit = 'N/A';
                                                                                    let qty = 1;

                                                                                    if (detail.KitNo === 0) {
                                                                                        nameKey = detail?.DispatchProductNameData?.productName || 'N/A';
                                                                                        category = detail?.DispatchCatogoryData?.categoryName || 'N/A';
                                                                                        subcategory = detail?.DispatchSubCatogoryData?.subCategoryName || 'N/A';
                                                                                        description = detail?.DispatchDiscription || 'N/A';
                                                                                        unit = detail?.DispatchUnit || 'N/A';
                                                                                        qty = Number(detail?.DispatchQty || 0);
                                                                                    } else {
                                                                                        if (displayedKits.has(detail.DispatchKitId)) return;
                                                                                        displayedKits.add(detail.DispatchKitId);

                                                                                        const kitProduct = kitproductdata?.find(k => k._id === detail.DispatchKitId);
                                                                                        nameKey = kitProduct?.productName || kitProduct?.KitName || 'Kit Product';
                                                                                        category = 'KitCategory';
                                                                                        subcategory = 'KitSubCategory';
                                                                                        description = 'N/A';
                                                                                        unit = 'N/A';
                                                                                        qty = 1;
                                                                                    }

                                                                                    if (!masterGrouped[nameKey]) {
                                                                                        masterGrouped[nameKey] = {
                                                                                            totalQty: 0,
                                                                                            category,
                                                                                            subcategory,
                                                                                            nameKey,
                                                                                            description,
                                                                                            unit,
                                                                                            purposes: new Set(),
                                                                                            fileNos: new Set(),
                                                                                            consumerNames: new Set()
                                                                                        };
                                                                                    }

                                                                                    masterGrouped[nameKey].totalQty += qty;
                                                                                    masterGrouped[nameKey].purposes.add(process.PurposeofDispatch);
                                                                                    masterGrouped[nameKey].fileNos.add(FileNo);
                                                                                    masterGrouped[nameKey].consumerNames.add(ConsumerName);
                                                                                });
                                                                            });
                                                                        });

                                                                        return Object.values(masterGrouped).map((item, index) => (
                                                                            <TableRow key={`grouped-${index}`}>
                                                                                {/* <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{Array.from(item.fileNos).join(', ')}</TableCell>
        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{Array.from(item.consumerNames).join(', ')}</TableCell> */}
                                                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{Array.from(item.purposes).join(', ')}</TableCell>
                                                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{item.category}</TableCell>
                                                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{item.subcategory}</TableCell>
                                                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{item.nameKey}</TableCell>
                                                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{item.description}</TableCell>
                                                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{item.unit}</TableCell>
                                                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{item.totalQty}</TableCell>
                                                                            </TableRow>
                                                                        ));
                                                                    })()}

                                                                    <TableRow>
                                                                        <TableCell colSpan={6} sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>
                                                                            Total Quantity
                                                                        </TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>
                                                                            {
                                                                                BulkData?.reduce((total, bulkItem) => {
                                                                                    return total + bulkItem?.ProcessData?.filter(p => p.bulkId === localStorage.getItem("bulkId"))?.reduce((processTotal, process) => {
                                                                                        const displayedKits = new Set();
                                                                                        return processTotal + process.DispatchDetails?.reduce((sum, detail) => {
                                                                                            if (detail.KitNo === 0) {
                                                                                                return sum + Number(detail.DispatchQty || 0);
                                                                                            } else {
                                                                                                if (displayedKits.has(detail.DispatchKitId)) return sum;
                                                                                                displayedKits.add(detail.DispatchKitId);
                                                                                                return sum + 1;
                                                                                            }
                                                                                        }, 0);
                                                                                    }, 0);
                                                                                }, 0)
                                                                            }
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>

                                                                {/* <TableBody>

                                                                    
                                                                    {Array.isArray(BulkData) && BulkData?.map((bulkItem, bulkIndex) => (
                                                                        bulkItem?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"))?.map((show, indexx) => {
                                                                            const displayedKits = new Set();

                                                                            return show?.DispatchDetails?.map((detail, detailIndex) => {
                                                                                let productName = 'N/A';




                                                                                if (detail?.KitNo === 0) {
                                                                                    productName = detail?.DispatchProductNameData?.productName || 'N/A';
                                                                                } else {
                                                                                    const kitProduct = kitproductdata?.find((k) => k?._id === detail.DispatchKitId);
                                                                                    if (kitProduct) {
                                                                                        if (displayedKits.has(detail.DispatchKitId)) {
                                                                                            return null; // Ignore duplicate kits
                                                                                        }
                                                                                        displayedKits.add(detail.DispatchKitId);
                                                                                        productName = kitProduct.productName || kitProduct.KitName || 'N/A';
                                                                                    }
                                                                                }

                                                                                // const productName = item?.KitNo === 0 ?
                                                                                //     item.DispatchProductNameData || 'N/A' :
                                                                                //     kitproductdata?.find((k) => k?._id === item.DispatchKitId)
                                                                                //     ;
                                                                                return (
                                                                                    <TableRow key={`${bulkIndex}-${detailIndex}`}>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{bulkItem.marketData.fillNo}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{bulkItem.marketData.ConsumerName}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{show.PurposeofDispatch}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchCatogoryData?.categoryName : 'KitCategory'}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchSubCatogoryData?.subCategoryName : "KitSubCategory"}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{productName}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchDiscription : 'N/A'}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchUnit : 'N/A'}</TableCell>
                                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchQty : '1'}</TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                            })
                                                                        })
                                                                    ))}
                                                                    <TableRow>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, borderLeft: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}></TableCell>
                                                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>Total Quantity</TableCell>
                                                                        <TableCell sx={{ borderBottom: `1px solid ${theme.palette.text.primary}`, borderRight: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', textAlign: 'center', padding: '10px' }}>
                                                                            {Array.isArray(BulkData) && BulkData?.reduce((total, value) => {
                                                                                return total + value?.ProcessData?.filter(v => v.bulkId === localStorage.getItem("bulkId"))?.reduce((processTotal, process) => {
                                                                                    const displayedKits = new Set(); // Initialize inside each process scope

                                                                                    return processTotal + process?.DispatchDetails?.reduce((detailTotal, detail) => {
                                                                                        if (detail?.KitNo !== 0) {
                                                                                            // If it's a kit, check if it's already counted
                                                                                            if (displayedKits.has(detail.DispatchKitId)) {
                                                                                                return detailTotal; // Skip duplicate kits
                                                                                            }
                                                                                            displayedKits.add(detail.DispatchKitId);
                                                                                        }

                                                                                        return detailTotal + Number(detail?.DispatchQty);
                                                                                    }, 0);
                                                                                }, 0);
                                                                            }, 0)}

                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody> */}
                                                            </Table>
                                                        </TableContainer >
                                                    )
                                                }
                                                <Grid container justifyContent="flex-end" style={{ paddingTop: '150px' }}>
                                                    <Grid item>
                                                        <Box
                                                            component="img"
                                                            className='stamp-sign'
                                                            src={'../../assets/images/stamp/stamp-1.svg'}
                                                            alt="Tvarit Energy LLP stamp"
                                                            sx={{ width: 150 }}
                                                        />
                                                        <Typography variant="body1" sx={{ fontWeight: '600' }}>Company Stamp & Sign</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Box >
                                        }
                                    </>
                                )
                            })()}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={downloadPDF}
                                sx={{ color: theme.palette.text.primary }}
                            // disabled={!AlldispatchProcess?.find(process => process.marketId === selectedprocess?._id)?.ProcessData?.length}
                            >
                                Download PDF
                            </Button>
                            <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                        </DialogActions>
                    </Dialog>
                </Stack>
            </form>
        </Box >
    )
}
export default BulkDispatch